<template>
	<div class="chat-box" @click="onClickChatBox()" @mousemove="readedMessage()" @dragover.prevent="onDragOver"
		@dragleave.prevent="onDragLeave" @drop.prevent="onDrop" :class="{ 'drag-over': isDragOver }">
		<el-container>
			<el-header height="50px" :class="{ 'is-msg-selecting': selectingMessages }">
				<template v-if="selectingMessages">
					<span class="select-forward-top" :class="{ disabled: !selectedMessages.length || forwardingMessages }"
						@click.stop="onForwardSelected">转发{{ selectedMessages.length ? ' ' + selectedMessages.length : '' }}</span>
					<span class="select-close" @click.stop="onCancelMultiSelect">取消</span>
				</template>
				<template v-else>
					<span class="h5-back" title="返回" @click.stop="onH5Back"><i class="el-icon-arrow-left"></i></span>
					<span class="chat-title" @click="onShowInfo">
						<span class="chat-title-name" :class="{ 'official-name': officialUserTag == 1 }">{{ title }}</span>
						<span :class="friend?.online ? 'online' : 'offline'">{{ !isGroup && friend ? friend.online ? '(在线)'
							: '(离线)' : '' }}</span>
						<official-tag v-if="isPrivate" :user-tag="officialUserTag" size="medium"></official-tag>
					</span>
					<div class="btn-side">
						<span title="分享" class="el-icon-share" @click="showQrcode = true"></span>
						<span title="刷新群聊信息" v-if="isGroup" class="el-icon-refresh more-info"
							@click="loadGroup(group.id)"></span>
						<span title="群聊详情" v-if="isGroup" class="el-icon-more more-info" @click="onClickMore"></span>
						<span title="清空聊天记录" v-if="chat.messages && chat.messages.length && !isGroup" class="clear-chat el-icon-delete"
							@click="onCleanMessage"></span>
					</div>
				</template>
			</el-header>
			<el-main style="padding: 0;">
				<el-container>
					<el-container class="content-box">
						<div v-if="isGroup && group.topMessage">
							<chat-top-message :group="group" :groupMembers="groupManagers" :msgInfo="group.topMessage"
								:headImage="headImage(group.topMessage)" :showName="showName(group.topMessage)"
								@locate="locateMessage">
							</chat-top-message>
						</div>
						<el-main class="im-chat-main" id="chatScrollBox"
							:class="{ 'is-msg-selecting': selectingMessages }"
							@scroll="onScroll" @dragstart.native.prevent>
							<div class="im-chat-box">
								<div v-for="(msgInfo, idx) in showMessages" :key="messageRowKey(msgInfo, idx)"
									class="chat-msg-wrap"
									:data-forward-key="canForwardMessage(msgInfo) ? messageSelectKey(msgInfo) : ''">
									<chat-message-item :id="msgInfo.id" @call="onCall(msgInfo.type)"
										:active="activeMessageIdx == showMinIdx + idx" :mine="msgInfo.sendId == mine.id"
										:headImage="headImage(msgInfo)" :showName="showName(msgInfo)" :msgInfo="msgInfo"
										:quoteShowName="showName(msgInfo.quoteMessage)" :group="group"
										:chatType="chat?.type" :groupMembers="groupMembers"
										@locateQuote="onLocateQuoteMessage" @delete="onDeleteMessage"
										@recall="onRecallMessage" @quote="onQuoteMessage" @top="onTopMessage"
										:groupManagers="groupManagers" @forward="onForwardMessage"
										:selecting="selectingMessages" :selected="isMessageSelected(msgInfo)"
										@toggle-select="onToggleSelectMessage" @multi-select="onStartMultiSelect"
										@forward-selected="onForwardSelected" @cancel-select="onCancelMultiSelect"
										@recallall="onRecallAll" @copy="onCopyMessage" @resend="onResendMessage"
										@cancel-upload="onCancelUploadMessage">
									</chat-message-item>
								</div>
							</div>
						</el-main>

						<div v-if="!isInBottom" class="scroll-to-bottom" @click="scrollToBottom"
							:style="{ bottom: (displayFooterHeight + 10) + 'px' }">
							{{ newMessageSize > 0 ? newMessageSize + '条新消息' : '回到底部' }}<span
								class="el-icon-arrow-down"></span>
						</div>

						<el-footer v-show="!selectingMessages" :height="displayFooterHeight + 'px'" class="im-chat-footer">
							<div class="resize-bar" @mousedown="onResizeMouseDown"></div>
							<div class="chat-tool-bar">
								<div title="表情" class="icon iconfont icon-emoji" ref="emotion"
									@click.stop="showEmotionBox()">
								</div>
								<div title="快捷话术" class="el-icon-notebook-2" @click="openQuickReplyDialog"></div>
								<div title="发送图片(可拖拽到聊天框上传)">
									<file-upload :action="'/image/upload'" :maxSize="100 * 1024 * 1024" :withResponseMeta="true"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
										@before="onImageBefore" @fail="onImageFail">
										<i class="el-icon-picture-outline"></i>
									</file-upload>
								</div>
								<div title="发送视频(可拖拽到聊天框上传)">
									<file-upload :action="'/video/upload'" :maxSize="500 * 1024 * 1024" :withResponseMeta="true"
										:fileTypes="['video/mp4', 'video/ogg', 'video/webm']" @before="onVideoBefore"
										 @fail="onVideoFail">
										<i class="el-icon-film"></i>
									</file-upload>
								</div>
								<div title="发送文件(可拖拽到聊天框上传)">
									<file-upload ref="fileUpload" :action="'/file/upload'" :maxSize="500 * 1024 * 1024" :withResponseMeta="true"
										@before="onFileBefore"  @fail="onFileFail">
										<i class="el-icon-wallet"></i>
									</file-upload>
								</div>
								<div title="回执消息" v-show="isGroup" class="icon iconfont icon-receipt"
									:class="isReceipt ? 'chat-tool-active' : ''" @click="onSwitchReceipt">
								</div>
								<div title="发送语音" class="el-icon-microphone" @click="showRecordBox()">
								</div>
								<div title="语音通话" v-show="isPrivate" class="el-icon-phone-outline"
									@click="showPrivateVideo('voice')">
								</div>
								<div title="语音通话" v-show="isShowVoice" class="el-icon-phone-outline"
									@click="onGroupVideo()">
								</div>
								<div title="视频通话" v-show="isPrivate" class="el-icon-video-camera"
									@click="showPrivateVideo('video')">
								</div>
								<div title="聊天记录" class="el-icon-chat-dot-round" @click="showHistoryBox()"></div>
								<div title="撤销 (Ctrl/Cmd+Z)"
									:class="['icon', 'el-icon-refresh-left', { 'chat-tool-disabled': !canUndo }]"
									@click="onUndo"
									:style="{ color: canUndo ? '' : '#ccc', cursor: canUndo ? 'pointer' : 'not-allowed' }">
								</div>
								<div title="恢复 (Ctrl/Cmd+Y 或 Ctrl/Cmd+Shift+Z)"
									:class="['icon', 'el-icon-refresh-right', { 'chat-tool-disabled': !canRedo }]"
									@click="onRedo"
									:style="{ color: canRedo ? '' : '#ccc', cursor: canRedo ? 'pointer' : 'not-allowed' }">
								</div>
							</div>
							<div class="send-content-area">
								<ChatInput :group="group" ref="chatInputEditor" :group-members="groupMembers"
									@submit="sendMessage" :chat="chat" @undo-redo-state="onUndoRedoState"
									@paste-files="onPasteFiles" @confirm-files="onConfirmSendFiles"
									:showFileConfirmDialog="showFileConfirmDialog" />
								<div v-if="quoteMessage" class="quote-message">
									<chat-quote-message :showName="showName(quoteMessage)" :msgInfo="quoteMessage">
									</chat-quote-message>
									<div class="quote-remove" @click="onQuoteMessage(null)"><i
											class="el-icon-close"></i></div>
								</div>
								<div class="send-btn-area">
									<el-button type="primary" icon="el-icon-s-promotion" :loading="lockMessage"
										:disabled="lockMessage"
										@click="notifySend()">发送</el-button>
								</div>
							</div>
						</el-footer>
					</el-container>
					<el-aside class="chat-group-side-box" width="280px" v-if="showSide">
						<chat-group-side :groupId="group.id" :groupMembers="groupMembers" @reload="loadGroup(group.id)"
							:chat="chat">
						</chat-group-side>
					</el-aside>
				</el-container>
			</el-main>
			<emotion ref="emoBox" @emotion="onEmotion"></Emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<group-member-selector v-if="isGroup" ref="rtcSel" :group="group"
				@complete="onInviteOk"></group-member-selector>
			<chat-selector ref="chatSel" :title="forwardSelectorTitle"></chat-selector>
			<rtc-group-join v-if="isGroup" ref="rtcJoin" :groupId="group.id"></rtc-group-join>
			<chat-history :isShow="showHistory" @close="showHistory = false" ref="chatHistory" :friend="friend"
				:group="group" @locateQuote="locateMessage" :groupMembers="groupMembers" :chat="chat" :propsText="searchHistory?.searchText"></chat-history>
		</el-container>
		<Qrcode :id="isGroup ? group.id : chat.targetId" :isGroup="isGroup" @close="closeQrcode" :name="chat.showName"
			v-if="showQrcode" :headImage="chat.headImage"></Qrcode>
		<el-dialog :visible.sync="showInfoDialog" width="800px" :title="isGroup ? '群聊信息' : '用户信息'"
			class="info-dialog info-dialog-optim">
			<div v-if="isGroup && group" class="info-content">
				<div class="info-avatar">
					<head-image :url="group.headImage" :name="group.showGroupName" :size="96" radius="18%" />
				</div>
				<div class="info-fields">
					<div class="info-row"><span class="info-label">群名：</span><span class="info-value">{{ group.name
					}}</span></div>
					<div class="info-row"><span class="info-label">群备注：</span><span class="info-value">{{
						group.showGroupName }}</span></div>
					<div class="info-row"><span class="info-label">成员数：</span><span class="info-value">{{
						groupCount }}</span></div>
					<div class="info-row"><span class="info-label">全员禁言：</span><span class="info-value">{{ group.isMuted
						? '是' : '否' }}</span></div>
					<div class="info-row"><span class="info-label">允许语音：</span><span class="info-value">{{
						group.isVoiceCall ? '是' : '否' }}</span></div>
					<div class="info-row"><span class="info-label">允许加好友：</span><span class="info-value">{{
						group.isAddFriend ? '是' : '否' }}</span></div>
					<div class="info-row"><span class="info-label">允许邀请：</span><span class="info-value">{{
						group.isInviteUser ? '是' : '否' }}</span></div>
					<div class="info-row"><span class="info-label">审核入群：</span><span class="info-value">{{
						group.isNeedApproval ? '是' : '否' }}</span></div>
					<div class="info-row">
						<span class="info-label">群公告：</span>
						<span class="info-value notice-value" v-html="group.notice || '暂无'"
							style="white-space: pre-line;"></span>
					</div>
				</div>
			</div>
			<div v-else-if="friend" class="info-content">
				<div class="info-avatar">
					<head-image :url="friend.headImage" :name="friend.nickName" :size="96" radius="50%" />
				</div>
				<div class="info-fields">
					<div class="info-row"><span class="info-label">用户ID：</span><span class="info-value">{{ friend.id
					}}</span></div>
					<div class="info-row"><span class="info-label">昵称：</span><span class="info-value info-value-name" :class="{ 'official-name': officialUserTag == 1 }">{{ friend.nickName
					}}<official-tag :user-tag="officialUserTag" size="medium"></official-tag></span></div>
					<div class="info-row"><span class="info-label">备注：</span><span class="info-value">{{
						friend.showNickName || '-' }}</span></div>
					<div class="info-row"><span class="info-label">签名：</span><span class="info-value">{{
						friend.signature || '-' }}</span></div>
					<div class="info-row"><span class="info-label">是否在线：</span><span class="info-value">{{ friend.online
						? '在线' : '离线' }}</span></div>
				</div>
			</div>
		</el-dialog>

		<!-- 拖拽提示遮罩 -->
		<div v-if="isDragOver" class="drag-overlay">
			<div class="drag-content">
				<i class="el-icon-upload"></i>
				<div class="drag-text">拖拽文件到此处发送</div>
				<div class="drag-tip">支持图片、视频、文档等文件</div>
			</div>
		</div>

		<!-- 文件发送确认对话框 -->
		<el-dialog title="确认发送文件" :visible.sync="showFileConfirmDialog" width="600px"
			:before-close="onCloseFileConfirmDialog">
			<div class="file-confirm-content">
				<div class="file-list">
					<div v-for="(file, index) in dragFiles" :key="index" class="file-item">
						<div v-if="file.type.startsWith('image/')" class="file-preview">
							<img :src="getFilePreviewUrl(file)" :alt="file.name" class="image-preview" />
						</div>
						<div v-else class="file-icon">
							<i v-if="file.type.startsWith('video/')" class="el-icon-film"></i>
							<i v-else class="el-icon-document"></i>
						</div>
						<div class="file-info">
							<div class="file-name">{{ file.name }}</div>
							<div class="file-size">{{ formatFileSize(file.size) }}</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onCloseFileConfirmDialog">取消</el-button>
				<el-button type="primary" @click="onConfirmSendFiles">确认发送(Enter)</el-button>
			</div>
		</el-dialog>
		<el-dialog title="快捷话术库" :visible.sync="showQuickReplyDialog" width="760px" class="quick-reply-dialog">
			<div class="quick-reply-toolbar">
				<el-input v-model.trim="quickReplyKeyword" size="small" clearable placeholder="搜索话术标题或内容"
					prefix-icon="el-icon-search"></el-input>
				<el-select v-model="quickReplyCategoryFilter" size="small" placeholder="全部分类">
					<el-option label="全部分类" value="all"></el-option>
					<el-option v-for="category in quickReplyCategories" :key="category" :label="category"
						:value="category"></el-option>
				</el-select>
				<div class="quick-reply-toolbar__actions">
					<el-button size="mini" @click="recoverPresetQuickReplies">恢复预置话术</el-button>
					<el-button size="mini" type="danger" plain @click="clearSharedQuickReplies">清空共享话术库</el-button>
				</div>
			</div>
			<div v-if="recentQuickReplies.length > 0" class="quick-reply-recent">
				<div class="quick-reply-recent__title">本会话最近使用（Enter 快速插入选中项）</div>
				<div class="quick-reply-recent__items">
					<el-tag v-for="item in recentQuickReplies" :key="`recent-${item.id}`" size="small" effect="plain"
						:class="['quick-reply-recent__tag', { 'is-selected': selectedRecentReplyId === item.id }]"
						@click="selectRecentQuickReply(item.id)" @dblclick.native="applyQuickReply(item)">
						{{ item.title }}
					</el-tag>
				</div>
			</div>
			<div class="quick-reply-list">
				<div class="quick-reply-item" v-for="item in filteredQuickReplies" :key="item.id">
					<div class="quick-reply-item__head">
						<div class="quick-reply-item__title">
							<i v-if="item.isPinned" class="el-icon-star-on quick-reply-item__pin-icon"></i>
							{{ item.title }}
						</div>
						<div class="quick-reply-item__tags">
							<el-tag v-if="item.usageCount > 0" size="mini" type="success">用过{{ item.usageCount }}次</el-tag>
							<el-tag size="mini" type="info">{{ item.category }}</el-tag>
						</div>
					</div>
					<div class="quick-reply-item__content">{{ item.content }}</div>
					<div class="quick-reply-item__actions">
						<el-button type="text" @click="applyQuickReply(item)">插入输入框</el-button>
						<el-button type="text" @click="startEditQuickReply(item)">编辑</el-button>
						<el-button type="text" @click="togglePinQuickReply(item)">{{ item.isPinned ? '取消置顶' : '置顶常用' }}</el-button>
						<el-button type="text" style="color: #f56c6c;" @click="removeQuickReply(item.id)">删除</el-button>
					</div>
				</div>
				<div v-if="filteredQuickReplies.length === 0" class="quick-reply-empty">{{ quickReplyEmptyText }}</div>
			</div>
			<div class="quick-reply-create">
				<div class="quick-reply-create__title">{{ editingQuickReplyId ? '编辑话术' : '新增话术' }}</div>
				<div class="quick-reply-create__row">
					<el-input v-model.trim="newQuickReply.title" size="small" maxlength="30" placeholder="话术标题"></el-input>
					<el-input v-model.trim="newQuickReply.category" size="small" maxlength="20" placeholder="分类，如：下载引导"></el-input>
				</div>
				<el-input v-model.trim="newQuickReply.content" type="textarea" :rows="3" maxlength="500" show-word-limit
					placeholder="输入话术内容，支持换行"></el-input>
				<div class="quick-reply-create__actions">
					<el-button size="small" @click="resetQuickReplyForm">{{ editingQuickReplyId ? '取消编辑' : '重置' }}</el-button>
					<el-button size="small" type="primary" @click="saveQuickReply">{{ editingQuickReplyId ? '保存修改' : '保存话术' }}</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { copyMessageContent, handleCopy } from "@/utils/common";
import { isH5 } from "@/utils/h5";
import { PRESIGNED_FILE_TYPE, uploadViaPresigned, wrapPresignedUploadFullResponse } from '@/utils/imagePresignedUpload.js';
import Emotion from "../common/Emotion.vue";
import FileUpload from "../common/FileUpload.vue";
import HeadImage from '../common/HeadImage.vue';
import OfficialTag from '../common/OfficialTag.vue';
import Qrcode from "../common/Qrcode.vue";
import GroupMemberSelector from "../group/GroupMemberSelector.vue";
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue";
import ChatAtBox from "./ChatAtBox.vue";
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatInput from "./ChatInput";
import ChatMessageItem from "./ChatMessageItem.vue";
import ChatQuoteMessage from "./ChatQuoteMessage.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatSelector from "./ChatSelector.vue";
import ChatTopMessage from "./ChatTopMessage.vue";
export default {
	name: "chatPrivate",
	components: {
		ChatInput,
		ChatMessageItem,
		FileUpload,
		ChatGroupSide,
		Emotion,
		ChatRecord,
		ChatHistory,
		ChatAtBox,
		GroupMemberSelector,
		RtcGroupJoin,
		ChatQuoteMessage,
		ChatTopMessage,
		ChatSelector,
		Qrcode,
		HeadImage,
		OfficialTag
	},
	props: {
		chat: {
			type: Object
		},
		searchHistory: {
			type: Object,
			default: () => ({
				searchText: '',
				show: false,
			})
		},
	},
	data() {
		return {
			showQrcode: false,
			handleCopy,
			userInfo: {},
			groupId: null,
			groupManagers: [],
			groupMembers: [],
			sendImageUrl: "",
			sendImageFile: "",
			placeholder: "",
			isReceipt: true, // 是否回执消息
			showRecord: false, // 是否显示语音录制弹窗
			showSide: false, // 是否显示群聊信息栏
			lockMessage: false, // 是否锁定发送，
			showMinIdx: 0, // 下标低于showMinIdx的消息不显示，否则页面会很卡
			showMaxIdx: -1, // 下标大于showMaxIdx的消息不显示，否则可能很卡
			activeMessageIdx: -1, //选择消息idx
			quoteMessage: null, // 被引用的消息
			reqQueue: [], // 等待发送的请求队列
			isSending: false, // 是否正在发
			showHistory: false,
			isInBottom: true, // 是否在底部
			newMessageSize: 0, // 新消息数量
			canUndo: false,
			canRedo: false,
			footerHeight: 220,
			resizing: false,
			startY: 0,
			startHeight: 220,
			showInfoDialog: false,
			isDragOver: false, // 拖拽区域是否覆盖
			showFileConfirmDialog: false, // 文件发送确认对话框
			dragFiles: [], // 拖拽的文件列表
			sendingFiles: false, // 是否正在发送文件
			hydratingChat: false,
			loadingOlder: false,
			uploadFileCache: {}, // tmpId -> 原始 File，用于发送失败后重试
			uploadRuntime: {}, // tmpId -> 上传测速运行时数据
			uploadServerStats: {}, // type -> { avgBps, samples }
			showQuickReplyDialog: false,
			quickReplyKeyword: '',
			quickReplyCategoryFilter: 'all',
			quickReplies: [],
			quickReplyRecentMap: {},
			quickReplyRecentIds: [],
			selectedRecentReplyId: '',
			editingQuickReplyId: '',
			newQuickReply: {
				title: '',
				category: '',
				content: ''
			},
			selectingMessages: false,
			selectedMessages: [],
			forwardingMessages: false
		}
	},
	created() {
		this.selectPress = null;
		this.selectTimer = null;
		this.selectSuppressClick = false;
		this.selectClickSwallower = null;
		this.selectTouchStamp = 0;
	},
	methods: {
		getQuickReplyStorageKey() {
			return 'quickRepliesShared';
		},
		getQuickReplyRecentStorageKey() {
			return 'quickRepliesRecentShared';
		},
		getCurrentChatQuickReplyKey() {
			if (!this.chat || !this.chat.type || !this.chat.targetId) {
				return '';
			}
			return `${this.chat.type}_${this.chat.targetId}`;
		},
		getPresetQuickReplies() {
			return [
				{
					id: 'preset-recharge-fallback',
					title: '充值通道异常引导',
					category: '充值问题',
					content: '您好，当前在线充值通道暂时异常，请您先不要重复操作，避免重复扣款。我这边可以为您安排人工充值通道，请按下一步操作。'
				},
				{
					id: 'preset-recharge-account',
					title: '人工充值收款信息',
					category: '充值问题',
					content: '请您转账到以下收款账户：\n收款人：XXX\n银行/渠道：XXX\n账号：XXX\n金额：XXX元\n备注：手机号后4位（便于快速核对）'
				},
				{
					id: 'preset-recharge-proof',
					title: '充值凭证确认',
					category: '充值问题',
					content: '转账完成后，请发送转账截图（需包含金额、时间、流水号）。我们收到后会在10-30分钟内为您核账入金。'
				},
				{
					id: 'preset-recharge-success',
					title: '充值到账确认',
					category: '充值问题',
					content: '您好，您的充值已核对完成，金额XXX元已到账。请您刷新页面查看余额，如未显示请退出后重新登录。'
				},
				{
					id: 'preset-profit-rule',
					title: '产品收益规则说明',
					category: '产品收益',
					content: '您好，产品收益以产品页展示规则为准，通常与持有金额、持有天数、产品类型有关。您告诉我产品名称，我可以帮您算一版预计收益。'
				},
				{
					id: 'preset-profit-risk',
					title: '收益波动与风险提示',
					category: '产品收益',
					content: '收益会随市场和产品规则波动，历史收益不代表未来收益。建议根据自身风险承受能力理性配置，不建议重仓。'
				},
				{
					id: 'preset-withdraw-rule',
					title: '提现规则标准答复',
					category: '提现问题',
					content: '平台支持提现到：支付宝、银行卡、虚拟货币。\n提现时间：周一到周五，每天支持1次提现。\n请在工作日提交，我们会按顺序处理。'
				},
				{
					id: 'preset-withdraw-limit',
					title: '今日提现次数已用完',
					category: '提现问题',
					content: '您今天的提现次数已用完（每日1次），请您明天再提交。我会优先帮您关注处理进度。'
				},
				{
					id: 'preset-download-links',
					title: 'APP下载链接',
					category: '下载APP',
					content: '您好，APP下载入口如下：\n安卓：XXX\n苹果：XXX\n如遇安装拦截，我可以一步一步指导您操作。'
				},
				{
					id: 'preset-download-android',
					title: '安卓安装失败处理',
					category: '下载APP',
					content: '安卓若提示“风险应用/禁止安装”，请在系统设置里开启“允许安装未知来源应用”，然后重新安装。'
				},
				{
					id: 'preset-download-ios',
					title: '苹果安装失败处理',
					category: '下载APP',
					content: '苹果若无法打开，请到“设置-通用-设备管理（或VPN与设备管理）”中信任对应证书后再打开。'
				},
				{
					id: 'preset-manual-escalation',
					title: '人工核验转接',
					category: '人工核验/升级处理',
					content: '我先帮您登记，马上为您转人工核验。为加快处理，请您补充：账号、问题时间、操作截图。'
				}
			].map((item, idx) => ({
				id: item.id || `preset-${idx + 1}`,
				title: item.title,
				category: item.category,
				content: item.content,
				isPinned: [
					'preset-recharge-account',
					'preset-recharge-proof',
					'preset-withdraw-rule',
					'preset-download-links'
				].includes(item.id),
				usageCount: 0,
				lastUsedAt: 0
			}));
		},
		normalizeQuickReplyItem(item) {
			return {
				id: item.id || `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
				title: (item.title || '').trim(),
				category: (item.category || '未分类').trim() || '未分类',
				content: (item.content || '').trim(),
				isPinned: !!item.isPinned,
				usageCount: Number(item.usageCount || 0),
				lastUsedAt: Number(item.lastUsedAt || 0)
			};
		},
		loadQuickReplies() {
			const key = this.getQuickReplyStorageKey();
			let list = [];
			let hasStoredValue = false;
			try {
				const raw = localStorage.getItem(key);
				if (raw !== null) {
					hasStoredValue = true;
					const parsed = JSON.parse(raw);
					if (Array.isArray(parsed)) {
						list = parsed;
					}
				}
			} catch (e) {
				console.warn('loadQuickReplies failed:', e);
			}
			const presets = this.getPresetQuickReplies();
			let normalizedList = Array.isArray(list) ? list : [];
			if (!hasStoredValue) {
				normalizedList = presets;
			}
			let normalizedReplies = normalizedList
				.map(item => this.normalizeQuickReplyItem(item))
				.filter(item => item.title && item.content);
			if (!hasStoredValue) {
				const existingKeys = new Set(
					normalizedReplies.map(item => `${item.category}__${item.title}`)
				);
				presets.forEach((preset) => {
					const key = `${preset.category}__${preset.title}`;
					if (!existingKeys.has(key)) {
						normalizedReplies.push(this.normalizeQuickReplyItem(preset));
						existingKeys.add(key);
					}
				});
			}
			this.quickReplies = normalizedReplies;
			this.persistQuickReplies();
		},
		clearSharedQuickReplies() {
			this.$confirm('确认清空共享话术库吗？清空后所有账号都会看到空话术库。', '清空共享话术库', {
				confirmButtonText: '确认清空',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.quickReplies = [];
				this.quickReplyRecentMap = {};
				this.quickReplyRecentIds = [];
				this.quickReplyKeyword = '';
				this.quickReplyCategoryFilter = 'all';
				this.selectedRecentReplyId = '';
				this.resetQuickReplyForm();
				this.persistQuickReplies();
				this.persistQuickReplyRecentMap();
				this.$message.success('共享话术库已清空');
			});
		},
		recoverPresetQuickReplies() {
			this.$confirm('确认恢复预置话术吗？当前共享话术会被覆盖。', '恢复预置话术', {
				confirmButtonText: '确认恢复',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.quickReplies = this.getPresetQuickReplies().map(item => this.normalizeQuickReplyItem(item));
				this.quickReplyRecentMap = {};
				this.quickReplyRecentIds = [];
				this.quickReplyKeyword = '';
				this.quickReplyCategoryFilter = 'all';
				this.selectedRecentReplyId = '';
				this.resetQuickReplyForm();
				this.persistQuickReplies();
				this.persistQuickReplyRecentMap();
				this.$message.success('已恢复预置话术');
			});
		},
		loadQuickReplyRecentMap() {
			const key = this.getQuickReplyRecentStorageKey();
			let map = {};
			try {
				const raw = localStorage.getItem(key);
				if (raw) {
					const parsed = JSON.parse(raw);
					if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
						map = parsed;
					}
				}
			} catch (e) {
				console.warn('loadQuickReplyRecentMap failed:', e);
			}
			this.quickReplyRecentMap = map;
			this.syncCurrentChatRecentIds();
		},
		persistQuickReplies() {
			try {
				localStorage.setItem(this.getQuickReplyStorageKey(), JSON.stringify(this.quickReplies));
			} catch (e) {
				console.warn('persistQuickReplies failed:', e);
			}
		},
		persistQuickReplyRecentMap() {
			try {
				localStorage.setItem(this.getQuickReplyRecentStorageKey(), JSON.stringify(this.quickReplyRecentMap));
			} catch (e) {
				console.warn('persistQuickReplyRecentMap failed:', e);
			}
		},
		syncCurrentChatRecentIds() {
			const chatKey = this.getCurrentChatQuickReplyKey();
			if (!chatKey) {
				this.quickReplyRecentIds = [];
				this.syncSelectedRecentQuickReply();
				return;
			}
			const ids = this.quickReplyRecentMap[chatKey];
			this.quickReplyRecentIds = Array.isArray(ids) ? ids : [];
			this.syncSelectedRecentQuickReply();
		},
		openQuickReplyDialog() {
			if (!this.quickReplies.length) {
				this.loadQuickReplies();
			}
			this.syncSelectedRecentQuickReply();
			this.showQuickReplyDialog = true;
		},
		selectRecentQuickReply(id) {
			this.selectedRecentReplyId = id || '';
		},
		syncSelectedRecentQuickReply() {
			const ids = this.quickReplyRecentIds || [];
			if (!ids.length) {
				this.selectedRecentReplyId = '';
				return;
			}
			if (!ids.includes(this.selectedRecentReplyId)) {
				this.selectedRecentReplyId = ids[0];
			}
		},
		applySelectedRecentQuickReply() {
			if (!this.showQuickReplyDialog) return false;
			const target = this.recentQuickReplies.find(item => item.id === this.selectedRecentReplyId) || this.recentQuickReplies[0];
			if (!target) return false;
			this.applyQuickReply(target);
			return true;
		},
		shouldIgnoreQuickReplyEnter(e) {
			if (!e || !e.target) return false;
			const target = e.target;
			const tagName = (target.tagName || '').toLowerCase();
			if (tagName === 'textarea') return true;
			if (tagName === 'input') return true;
			if (target.isContentEditable) return true;
			const className = target.className || '';
			if (typeof className === 'string' && (className.includes('el-input__inner') || className.includes('el-textarea__inner'))) {
				return true;
			}
			return false;
		},
		resetQuickReplyForm() {
			this.editingQuickReplyId = '';
			this.newQuickReply = {
				title: '',
				category: '',
				content: ''
			};
		},
		startEditQuickReply(item) {
			if (!item) return;
			this.editingQuickReplyId = item.id;
			this.newQuickReply = {
				title: item.title,
				category: item.category,
				content: item.content
			};
		},
		saveQuickReply() {
			const title = (this.newQuickReply.title || '').trim();
			const category = (this.newQuickReply.category || '未分类').trim() || '未分类';
			const content = (this.newQuickReply.content || '').trim();
			if (!title) {
				this.$message.warning('请填写话术标题');
				return;
			}
			if (!content) {
				this.$message.warning('请填写话术内容');
				return;
			}
			if (this.editingQuickReplyId) {
				this.quickReplies = this.quickReplies.map(item => item.id === this.editingQuickReplyId
					? { ...item, title, category, content }
					: item);
				this.$message.success('话术已更新');
			} else {
				this.quickReplies.unshift(this.normalizeQuickReplyItem({
					id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
					title,
					category,
					content
				}));
				this.$message.success('话术已保存');
			}
			this.persistQuickReplies();
			this.resetQuickReplyForm();
		},
		togglePinQuickReply(item) {
			if (!item) return;
			this.quickReplies = this.quickReplies.map(cur => cur.id === item.id
				? { ...cur, isPinned: !cur.isPinned }
				: cur);
			this.persistQuickReplies();
		},
		removeQuickReply(id) {
			this.quickReplies = this.quickReplies.filter(item => item.id !== id);
			if (this.editingQuickReplyId === id) {
				this.resetQuickReplyForm();
			}
			Object.keys(this.quickReplyRecentMap).forEach((chatKey) => {
				const ids = this.quickReplyRecentMap[chatKey];
				if (Array.isArray(ids)) {
					this.quickReplyRecentMap[chatKey] = ids.filter(itemId => itemId !== id).slice(0, 8);
				}
			});
			this.persistQuickReplies();
			this.persistQuickReplyRecentMap();
			this.syncCurrentChatRecentIds();
			this.syncSelectedRecentQuickReply();
		},
		recordQuickReplyRecentUse(id) {
			if (!id) return;
			const chatKey = this.getCurrentChatQuickReplyKey();
			if (!chatKey) return;
			const cur = Array.isArray(this.quickReplyRecentMap[chatKey]) ? this.quickReplyRecentMap[chatKey] : [];
			const next = [id, ...cur.filter(itemId => itemId !== id)].slice(0, 8);
			this.$set(this.quickReplyRecentMap, chatKey, next);
			this.quickReplyRecentIds = next;
			this.syncSelectedRecentQuickReply();
			this.persistQuickReplyRecentMap();
		},
		applyQuickReply(item) {
			if (!item || !item.content) return;
			const usedAt = Date.now();
			this.quickReplies = this.quickReplies.map(cur => cur.id === item.id
				? {
					...cur,
					usageCount: Number(cur.usageCount || 0) + 1,
					lastUsedAt: usedAt
				}
				: cur);
			this.persistQuickReplies();
			this.recordQuickReplyRecentUse(item.id);
			this.$refs.chatInputEditor.insertQuickReply(item.content);
			this.showQuickReplyDialog = false;
			this.$nextTick(() => this.$refs.chatInputEditor.focus());
		},
		getUploadErrorMessage(error, canceled = false) {
			if (canceled || (error && (error.code === 'ERR_CANCELED' || error.name === 'CanceledError'))) {
				return '已取消上传';
			}
			const status = error && error.response ? error.response.status : 0;
			if (status === 413) return '文件过大，上传失败';
			if (status === 415) return '文件格式不支持';
			if (status === 403) return '无上传权限';
			if (status >= 500) return '服务器繁忙，请稍后重试';
			if (!navigator.onLine) return '网络已断开，请检查网络';
			return (error && error.response && error.response.data && (error.response.data.message || error.response.data.msg))
				|| (error && error.message)
				|| '上传失败，请重试';
		},
		getUploadTypeKey(msgInfo, file) {
			const type = msgInfo?.type || file?.msgInfo?.type;
			if (type == this.$enums.MESSAGE_TYPE.IMAGE) return 'image';
			if (type == this.$enums.MESSAGE_TYPE.VIDEO) return 'video';
			if (type == this.$enums.MESSAGE_TYPE.FILE) return 'file';
			return 'unknown';
		},
		normalizeUploadResponse(rawResponse, type, file) {
			const maybeFull = rawResponse && typeof rawResponse === 'object'
				&& Object.prototype.hasOwnProperty.call(rawResponse, 'data')
				&& Object.prototype.hasOwnProperty.call(rawResponse, 'headers');
			const headers = maybeFull ? (rawResponse.headers || {}) : {};
			const responseData = maybeFull ? rawResponse.data : rawResponse;
			const data = responseData && typeof responseData === 'object' ? responseData : null;
			if (!data) {
				return {
					payload: responseData,
					serverMetrics: {}
				};
			}
			// 兼容后端透传 uploadMeta/serverMetrics 的场景：
			// 1) data.uploadMeta
			// 2) data.serverMetrics
			// 3) data.meta.upload/server
			const meta = data.uploadMeta || data.serverMetrics || data.meta?.upload || data.meta?.server || {};
			const payload = (type === 'file')
				? (data.url ? data.url : (data.payload?.url ? data.payload.url : responseData))
				: (data.payload ? data.payload : responseData);
			const size = Number(file?.size || 0);
			const headerNumber = (name) => {
				const v = headers[name] ?? headers[name.toLowerCase()];
				return Number(v);
			};
			const msCandidates = [
				Number(meta.serverElapsedMs),
				Number(meta.uploadElapsedMs),
				Number(meta.receiveMs),
				Number(meta.durationMs),
				Number(data.serverElapsedMs),
				Number(data.uploadElapsedMs),
				Number(data.receiveMs),
				Number(data.durationMs),
				headerNumber('x-server-elapsed-ms'),
				headerNumber('x-upload-elapsed-ms'),
				headerNumber('x-upload-receive-ms')
			].filter(v => Number.isFinite(v) && v > 0);
			const bpsCandidates = [
				Number(meta.serverUploadBps),
				Number(meta.serverSpeedBps),
				Number(meta.uploadBps),
				Number(meta.throughputBps),
				Number(meta.transferRateBps),
				Number(data.serverUploadBps),
				Number(data.serverSpeedBps),
				Number(data.uploadBps),
				Number(data.throughputBps),
				Number(data.transferRateBps),
				headerNumber('x-server-upload-bps'),
				headerNumber('x-upload-throughput-bps')
			].filter(v => Number.isFinite(v) && v > 0);
			let serverBps = bpsCandidates.length ? bpsCandidates[0] : 0;
			if (!serverBps && msCandidates.length && size > 0) {
				serverBps = (size * 1000) / msCandidates[0];
			}
			return {
				payload,
				serverMetrics: {
					serverBps: Number.isFinite(serverBps) && serverBps > 0 ? serverBps : 0
				}
			};
		},
		recordServerSpeed(typeKey, serverBps) {
			if (!typeKey || !Number.isFinite(serverBps) || serverBps <= 0) {
				return;
			}
			const cur = this.uploadServerStats[typeKey] || { avgBps: 0, samples: 0 };
			const nextSamples = Math.min(cur.samples + 1, 20);
			const nextAvg = cur.avgBps > 0 ? (cur.avgBps * 0.8 + serverBps * 0.2) : serverBps;
			this.$set(this.uploadServerStats, typeKey, {
				avgBps: nextAvg,
				samples: nextSamples
			});
		},
		getServerAvgBps(typeKey) {
			const stat = this.uploadServerStats[typeKey];
			return stat && Number.isFinite(stat.avgBps) ? stat.avgBps : 0;
		},
		onCancelUploadMessage(msgInfo) {
			if (!msgInfo || !msgInfo.tmpId) {
				return;
			}
			const file = this.uploadFileCache[msgInfo.tmpId];
			if (file && file.uploadController) {
				file.uploadController.abort();
			}
		},
		formatDuration(seconds) {
			if (!Number.isFinite(seconds) || seconds <= 0) {
				return '1s';
			}
			if (seconds < 60) {
				return `${Math.ceil(seconds)}s`;
			}
			const min = Math.floor(seconds / 60);
			const sec = Math.ceil(seconds % 60);
			return `${min}m ${sec}s`;
		},
		formatUploadSpeed(bytesPerSecond) {
			if (!Number.isFinite(bytesPerSecond) || bytesPerSecond <= 0) {
				return '';
			}
			if (bytesPerSecond >= 1024 * 1024) {
				return `${(bytesPerSecond / 1024 / 1024).toFixed(2)} MB/s`;
			}
			if (bytesPerSecond >= 1024) {
				return `${(bytesPerSecond / 1024).toFixed(1)} KB/s`;
			}
			return `${Math.round(bytesPerSecond)} B/s`;
		},
		updateUploadProgress(file, progressEvent, force = false) {
			const tmpId = file?.msgInfo?.tmpId;
			const chat = file?.chat || this.chat;
			if (!tmpId || !chat || !progressEvent) {
				return;
			}
			if (!this.uploadRuntime[tmpId]) {
				this.$set(this.uploadRuntime, tmpId, {
					lastLoaded: 0,
					lastTs: Date.now(),
					lastCommitTs: 0,
					speedBps: 0,
				});
			}
			const runtime = this.uploadRuntime[tmpId];
			const now = Date.now();
			const total = Number(progressEvent.total || file.size || 0);
			const loadedRaw = Number(progressEvent.loaded || 0);
			const loaded = total > 0 ? Math.min(loadedRaw, total) : loadedRaw;
			const deltaLoaded = Math.max(0, loaded - runtime.lastLoaded);
			const deltaTs = Math.max(1, now - runtime.lastTs);
			if (deltaLoaded > 0) {
				const instantSpeed = (deltaLoaded * 1000) / deltaTs;
				runtime.speedBps = runtime.speedBps > 0 ? (runtime.speedBps * 0.7 + instantSpeed * 0.3) : instantSpeed;
			}
			runtime.lastLoaded = loaded;
			runtime.lastTs = now;

			if (!force && now - runtime.lastCommitTs < 250 && loaded < total) {
				return;
			}
			runtime.lastCommitTs = now;

			let uploadPercent = total > 0 ? Math.min(100, Math.floor((loaded / total) * 100)) : 0;
			// 在服务端最终确认成功之前，前端展示最多到 99%
			if (uploadPercent >= 100) {
				uploadPercent = 99;
			}
			const typeKey = this.getUploadTypeKey(file?.msgInfo, file);
			const serverAvgBps = this.getServerAvgBps(typeKey);
			// 融合策略：优先取更保守值，避免仅按前端测速导致 ETA 偏乐观
			let blendedBps = runtime.speedBps;
			if (serverAvgBps > 0) {
				if (blendedBps > 0) {
					blendedBps = Math.min(blendedBps, serverAvgBps);
				} else {
					blendedBps = serverAvgBps;
				}
			}
			const speedText = this.formatUploadSpeed(blendedBps);
			const etaSeconds = blendedBps > 0 && total > loaded ? (total - loaded) / blendedBps : 1;
			// 未上传成功前，预计剩余时间至少显示 1s，避免出现 0
			const etaText = total > loaded ? this.formatDuration(etaSeconds) : '1s';
			const uploadTip = `上传中 ${uploadPercent}%` + (speedText ? ` · ${speedText}` : '') + ` · 预计剩余 ${etaText}`;

			const patch = {
				...file.msgInfo,
				loadStatus: 'loading',
				uploadPercent,
				uploadSpeedText: speedText,
				uploadEtaText: etaText,
				uploadTip
			};
			file.msgInfo = { ...file.msgInfo, ...patch };
			this.$store.commit('updateMessage', [patch, chat]);
		},
		resetUploadProgress(msgInfo, status = 'loading') {
			if (!msgInfo) {
				return;
			}
			return {
				...msgInfo,
				loadStatus: status,
				uploadPercent: status === 'ok' ? 100 : 0,
				uploadSpeedText: '',
				uploadEtaText: '',
				uploadTip: ''
			};
		},
		cleanupUploadRuntime(tmpId) {
			if (tmpId && this.uploadRuntime[tmpId]) {
				this.$delete(this.uploadRuntime, tmpId);
			}
		},
		keyDown(e) {
			if (this.selectingMessages && (e.key === 'Escape' || e.keyCode === 27)) {
				e.preventDefault();
				this.onCancelMultiSelect();
				return;
			}
			if (e.keyCode === 13 && this.showFileConfirmDialog) {
				this.onConfirmSendFiles();
				return;
			}
			if (
				e.keyCode === 13 &&
				this.showQuickReplyDialog &&
				!e.isComposing &&
				!e.ctrlKey &&
				!e.metaKey &&
				!e.shiftKey
			) {
				if (this.shouldIgnoreQuickReplyEnter(e)) {
					return;
				}
				const applied = this.applySelectedRecentQuickReply();
				if (applied) {
					e.preventDefault();
					e.stopPropagation();
				}
			}
		},
		onCleanMessage() {
			this.$confirm(`确认删除与用户'${this.title}'的聊天记录吗?`, '清空聊天记录?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let chatIdx = this.$store.getters.findChatIdx(this.chat);
				this.$store.commit("cleanMessage", chatIdx);
				this.$message.success(`您清空了'${this.title}'的聊天记录`);
			})
		},
		closeQrcode() {
			this.showQrcode = false;
		},
		moveChatToTop(chat) {
			let chatIdx = this.$store.getters.findChatIdx(chat || this.chat);
			if (chatIdx == null || chatIdx < 0) {
				return;
			}
			this.$store.commit("chatToTop", chatIdx);
		},
		messageRowKey(msgInfo, idx) {
			const chat = this.chat || {};
			const id = msgInfo && (msgInfo.id || msgInfo.tmpId || msgInfo.seqNo);
			const suffix = id != null && id !== '' ? id : ('i' + this.showMinIdx + ':' + idx);
			return String(chat.type) + ':' + String(chat.targetId) + ':' + suffix;
		},
		canQuoteMessage(msgInfo) {
			if (!msgInfo) {
				return false;
			}
			return this.$store.getters.messageBelongsToChat(this.chat, msgInfo);
		},
		onClickChatBox() {
			// 关闭表情窗口
			// this.$refs.emoBox.close();
			// 取消消息选中
			this.activeMessageIdx = -1;
		},
		// 拖拽文件处理
		onDragOver(e) {
			this.isDragOver = true;
		},
		onDragLeave(e) {
			// 检查是否真的离开了拖拽区域
			const rect = e.currentTarget.getBoundingClientRect();
			const x = e.clientX;
			const y = e.clientY;

			if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
				this.isDragOver = false;
			}
		},
		onDrop(e) {
			this.isDragOver = false;
			const files = e.dataTransfer.files;
			if (files.length === 0) {
				return;
			}

			// 显示文件确认对话框
			this.showFileConfirmDialog = true;
			this.dragFiles = Array.from(files);
		},
		// 处理从输入组件拖拽的文件
		onDragFiles(files) {
			this.showFileConfirmDialog = true;
			this.dragFiles = Array.from(files);
		},
		// 关闭文件确认对话框
		onCloseFileConfirmDialog() {
			// 清理图片预览URL，避免内存泄漏
			this.dragFiles.forEach(file => {
				if (file.type.startsWith('image/') && file.previewUrl) {
					URL.revokeObjectURL(file.previewUrl);
				}
			});
			this.showFileConfirmDialog = false;
			this.dragFiles = [];
		},
		// 确认发送文件
		async onConfirmSendFiles() {
			try {
				this.showFileConfirmDialog = false;
				for (let i = 0; i < this.dragFiles.length; i++) {
					const file = this.dragFiles[i];
					if (file.type.startsWith('image/')) {
						await this.sendImageMessage(file);
					} else if (file.type.startsWith('video/')) {
						await this.sendVideoMessage(file);
					} else {
						await this.sendFileMessage(file);
					}
				}
				this.$message.success('文件发送成功');
			} catch (error) {
				console.error('发送文件失败:', error);
				this.$message.error('文件发送失败');
				this.onCloseFileConfirmDialog();
			} finally {
				// 确保无论成功还是失败都清理资源
				this.onCloseFileConfirmDialog();
			}
		},
		// 格式化文件大小
		formatFileSize(bytes) {
			if (bytes === 0) return '0 B';
			const k = 1024;
			const sizes = ['B', 'KB', 'MB', 'GB'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
		},
		// 获取文件预览URL
		getFilePreviewUrl(file) {
			if (file.type.startsWith('image/')) {
				if (!file.previewUrl) {
					file.previewUrl = URL.createObjectURL(file);
				}
				return file.previewUrl;
			}
			return '';
		},
		onCall(type) {
			if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
				this.showPrivateVideo('voice');
			} else if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				this.showPrivateVideo('video');
			}
		},
		onSwitchReceipt() {
			this.isReceipt = !this.isReceipt;
			this.refreshPlaceHolder();
		},
		onImageSuccess(rawData, file) {
			const { payload: data, serverMetrics } = this.normalizeUploadResponse(rawData, 'image', file);
			this.recordServerSpeed(this.getUploadTypeKey(file?.msgInfo, file), serverMetrics.serverBps);
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo = this.resetUploadProgress(msgInfo, 'ok');
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt;
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.id = m.id;
				this.isReceipt = false;
				this.$store.commit("insertMessage", [msgInfo, file.chat]);
				this.$delete(this.uploadFileCache, msgInfo.tmpId);
				this.cleanupUploadRuntime(msgInfo.tmpId);
			}).catch(() => {
				msgInfo = this.resetUploadProgress(msgInfo, 'fail');
				msgInfo.failReason = '消息发送失败，请重试';
				this.$store.commit("insertMessage", [msgInfo, file.chat]);
			});
		},
		onImageFail(e, file, canceled = false) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo = this.resetUploadProgress(msgInfo, 'fail');
			msgInfo.failReason = this.getUploadErrorMessage(e, canceled);
			this.$store.commit("insertMessage", [msgInfo, file.chat]);
			this.cleanupUploadRuntime(msgInfo.tmpId);
		},
		onImageBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				originUrl: url,
				thumbUrl: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				fileId: file.uid,
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: this.$enums.MESSAGE_TYPE.IMAGE,
				readedCount: 0,
				loadStatus: "loading",
				uploadPercent: 0,
				uploadSpeedText: '',
				uploadEtaText: '',
				uploadTip: '上传中 0%',
				status: this.$enums.MESSAGE_STATUS.UNSEND,
				chatType: this.chat.type.toLowerCase(),
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 借助file对象保存
			file.msgInfo = msgInfo;
			file.chat = this.chat;
			this.$set(this.uploadFileCache, msgInfo.tmpId, file);
		},
		onFileSuccess(rawData, file) {
			const { payload: url, serverMetrics } = this.normalizeUploadResponse(rawData, 'file', file);
			this.recordServerSpeed(this.getUploadTypeKey(file?.msgInfo, file), serverMetrics.serverBps);
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo = this.resetUploadProgress(msgInfo, 'ok');
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt

			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.id = m.id;
				this.isReceipt = false;
				this.refreshPlaceHolder();
				this.$store.commit("insertMessage", [msgInfo, file.chat]);
				this.$delete(this.uploadFileCache, msgInfo.tmpId);
				this.cleanupUploadRuntime(msgInfo.tmpId);
			}).catch(() => {
				msgInfo = this.resetUploadProgress(msgInfo, 'fail');
				msgInfo.failReason = '消息发送失败，请重试';
				this.$store.commit("insertMessage", [msgInfo, file.chat]);
			});
		},
		onFileFail(e, file, canceled = false) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo = this.resetUploadProgress(msgInfo, 'fail');
			msgInfo.failReason = this.getUploadErrorMessage(e, canceled);
			this.$store.commit("insertMessage", [msgInfo, file.chat]);
			this.cleanupUploadRuntime(msgInfo.tmpId);
		},
		onFileBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}

			let url = URL.createObjectURL(file);
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: this.$enums.MESSAGE_TYPE.FILE,
				loadStatus: "loading",
				uploadPercent: 0,
				uploadSpeedText: '',
				uploadEtaText: '',
				uploadTip: '上传中 0%',
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.UNSEND,
				chatType: this.chat.type.toLowerCase(),
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 借助file对象透传
			file.msgInfo = msgInfo;
			file.chat = this.chat;
			this.$set(this.uploadFileCache, msgInfo.tmpId, file);
		},
		onVideoSuccess(rawData, file) {
			const { payload: data, serverMetrics } = this.normalizeUploadResponse(rawData, 'video', file);
			this.recordServerSpeed(this.getUploadTypeKey(file?.msgInfo, file), serverMetrics.serverBps);
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo = this.resetUploadProgress(msgInfo, 'ok');
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt;
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.id = m.id;
				this.isReceipt = false;
				this.$store.commit("insertMessage", [msgInfo, file.chat]);
				this.$delete(this.uploadFileCache, msgInfo.tmpId);
				this.cleanupUploadRuntime(msgInfo.tmpId);
			}).catch(() => {
				msgInfo = this.resetUploadProgress(msgInfo, 'fail');
				msgInfo.failReason = '消息发送失败，请重试';
				this.$store.commit("insertMessage", [msgInfo, file.chat]);
			});
		},
		onVideoFail(e, file, canceled = false) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo = this.resetUploadProgress(msgInfo, 'fail');
			msgInfo.failReason = this.getUploadErrorMessage(e, canceled);
			this.$store.commit("insertMessage", [msgInfo, file.chat]);
			this.cleanupUploadRuntime(msgInfo.tmpId);
		},
		onVideoBefore(file) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				videoUrl: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: this.$enums.MESSAGE_TYPE.VIDEO,
				loadStatus: "loading",
				uploadPercent: 0,
				uploadSpeedText: '',
				uploadEtaText: '',
				uploadTip: '上传中 0%',
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.UNSEND,
				chatType: this.chat.type.toLowerCase(),
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 借助file对象透传
			file.msgInfo = msgInfo;
			file.chat = this.chat;
			this.$set(this.uploadFileCache, msgInfo.tmpId, file);
		},
		cacheUploadFile(tmpId, file) {
			if (tmpId && file) {
				this.$set(this.uploadFileCache, tmpId, file);
			}
		},
		async resolveUploadFile(msgInfo) {
			const tmpId = msgInfo.tmpId;
			if (tmpId && this.uploadFileCache[tmpId]) {
				return this.uploadFileCache[tmpId];
			}
			let content;
			try {
				content = JSON.parse(msgInfo.content);
			} catch (e) {
				return null;
			}
			const blobUrl = content.url || content.originUrl || content.thumbUrl || content.videoUrl;
			if (!blobUrl || blobUrl.indexOf('blob:') !== 0) {
				return null;
			}
			try {
				const response = await fetch(blobUrl);
				const blob = await response.blob();
				let name = content.name;
				if (!name) {
					if (msgInfo.type == this.$enums.MESSAGE_TYPE.IMAGE) {
						name = 'image.png';
					} else if (msgInfo.type == this.$enums.MESSAGE_TYPE.VIDEO) {
						name = 'video.mp4';
					} else {
						name = 'file';
					}
				}
				return new File([blob], name, { type: blob.type || 'application/octet-stream' });
			} catch (e) {
				return null;
			}
		},
		patchMessageLoadStatus(msgInfo, loadStatus, failReason = '') {
			this.$store.commit('updateMessage', [{
				...msgInfo,
				loadStatus,
				uploadPercent: loadStatus === 'loading' ? 0 : (loadStatus === 'ok' ? 100 : 0),
				uploadSpeedText: '',
				uploadEtaText: '',
				uploadTip: '',
				failReason
			}, this.chat]);
		},
		async onResendMessage(msgInfo) {
			if (!msgInfo || msgInfo.loadStatus !== 'fail' || !msgInfo.selfSend) {
				return;
			}
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			const type = msgInfo.type;
			if (type == this.$enums.MESSAGE_TYPE.FILE) {
				await this.resendFileMessage(msgInfo);
			} else if (type == this.$enums.MESSAGE_TYPE.IMAGE) {
				await this.resendImageMessage(msgInfo);
			} else if (type == this.$enums.MESSAGE_TYPE.VIDEO) {
				await this.resendVideoMessage(msgInfo);
			}
		},
		async resendFileMessage(msgInfo) {
			const file = await this.resolveUploadFile(msgInfo);
			if (!file) {
				this.$message.error('无法获取原文件，请重新选择文件发送');
				return;
			}
			this.cacheUploadFile(msgInfo.tmpId, file);
			this.patchMessageLoadStatus(msgInfo, 'loading');
			try {
				file.uploadController = new AbortController();
				file.msgInfo = { ...msgInfo };
				file.chat = this.chat;
				const filePayload = await uploadViaPresigned(file, {
					fileType: PRESIGNED_FILE_TYPE.FILE,
					onUploadProgress: (progressEvent) => this.updateUploadProgress(file, progressEvent),
					signal: file.uploadController.signal
				});
				const data = wrapPresignedUploadFullResponse(filePayload);
				const normalized = this.normalizeUploadResponse(data, 'file', file);
				this.recordServerSpeed(this.getUploadTypeKey(msgInfo, file), normalized.serverMetrics.serverBps);
				const url = normalized.payload?.url || normalized.payload;
				const payload = {
					...msgInfo,
					content: JSON.stringify({ name: file.name, size: file.size, url }),
					loadStatus: 'loading',
					receipt: this.isReceipt
				};
				const m = await this.sendMessageRequest(payload);
				this.$store.commit('updateMessage', [{
					...payload,
					loadStatus: 'ok',
					id: m.id
				}, this.chat]);
				this.$delete(this.uploadFileCache, msgInfo.tmpId);
				this.cleanupUploadRuntime(msgInfo.tmpId);
				this.isReceipt = false;
				this.refreshPlaceHolder();
			} catch (e) {
				this.patchMessageLoadStatus(msgInfo, 'fail', this.getUploadErrorMessage(e));
				this.cleanupUploadRuntime(msgInfo.tmpId);
				this.$message.error('重新发送失败');
			}
		},
		async resendImageMessage(msgInfo) {
			const file = await this.resolveUploadFile(msgInfo);
			if (!file) {
				this.$message.error('无法获取原图片，请重新选择图片发送');
				return;
			}
			this.cacheUploadFile(msgInfo.tmpId, file);
			this.patchMessageLoadStatus(msgInfo, 'loading');
			try {
				file.uploadController = new AbortController();
				file.msgInfo = { ...msgInfo };
				file.chat = this.chat;
				const imagePayload = await uploadViaPresigned(file, {
					fileType: PRESIGNED_FILE_TYPE.IMAGE,
					onUploadProgress: (progressEvent) => this.updateUploadProgress(file, progressEvent),
					signal: file.uploadController.signal
				});
				const data = wrapPresignedUploadFullResponse(imagePayload);
				const normalized = this.normalizeUploadResponse(data, 'image', file);
				this.recordServerSpeed(this.getUploadTypeKey(msgInfo, file), normalized.serverMetrics.serverBps);
				const payload = {
					...msgInfo,
					content: JSON.stringify(normalized.payload),
					loadStatus: 'loading',
					receipt: this.isReceipt
				};
				const m = await this.sendMessageRequest(payload);
				this.$store.commit('updateMessage', [{
					...payload,
					loadStatus: 'ok',
					id: m.id
				}, this.chat]);
				this.$delete(this.uploadFileCache, msgInfo.tmpId);
				this.cleanupUploadRuntime(msgInfo.tmpId);
				this.isReceipt = false;
			} catch (e) {
				this.patchMessageLoadStatus(msgInfo, 'fail', this.getUploadErrorMessage(e));
				this.cleanupUploadRuntime(msgInfo.tmpId);
				this.$message.error('重新发送失败');
			}
		},
		async resendVideoMessage(msgInfo) {
			const file = await this.resolveUploadFile(msgInfo);
			if (!file) {
				this.$message.error('无法获取原视频，请重新选择视频发送');
				return;
			}
			this.cacheUploadFile(msgInfo.tmpId, file);
			this.patchMessageLoadStatus(msgInfo, 'loading');
			try {
				file.uploadController = new AbortController();
				file.msgInfo = { ...msgInfo };
				file.chat = this.chat;
				const videoPayload = await uploadViaPresigned(file, {
					fileType: PRESIGNED_FILE_TYPE.VIDEO,
					onUploadProgress: (progressEvent) => this.updateUploadProgress(file, progressEvent),
					signal: file.uploadController.signal
				});
				const data = wrapPresignedUploadFullResponse(videoPayload);
				const normalized = this.normalizeUploadResponse(data, 'video', file);
				this.recordServerSpeed(this.getUploadTypeKey(msgInfo, file), normalized.serverMetrics.serverBps);
				const payload = {
					...msgInfo,
					content: JSON.stringify(normalized.payload),
					loadStatus: 'loading',
					receipt: this.isReceipt
				};
				const m = await this.sendMessageRequest(payload);
				this.$store.commit('updateMessage', [{
					...payload,
					loadStatus: 'ok',
					id: m.id
				}, this.chat]);
				this.$delete(this.uploadFileCache, msgInfo.tmpId);
				this.cleanupUploadRuntime(msgInfo.tmpId);
				this.isReceipt = false;
			} catch (e) {
				this.patchMessageLoadStatus(msgInfo, 'fail', this.getUploadErrorMessage(e));
				this.cleanupUploadRuntime(msgInfo.tmpId);
				this.$message.error('重新发送失败');
			}
		},
		onClickMore() {
			this.showSide = !this.showSide;
			if (this.showSide) {
				// 刷新一下群和成员信息
				this.loadGroup(this.group.id);
			}
		},
		onScroll(e) {
			if (this.selectPress && this.selectPress.armed) {
				this.applySelectRange(this.selectPress.lastY);
				this.$nextTick(() => {
					if (this.selectPress && this.selectPress.armed) {
						this.applySelectRange(this.selectPress.lastY);
					}
				});
			}
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop

			// 滚到顶部
			if (scrollTop < 30) {
				if (this.showMinIdx > 0) {
					this.showMinIdx = this.showMinIdx > 20 ? this.showMinIdx - 20 : 0;
				} else {
					this.loadOlderMessages(scrollElement);
				}
			}
			// 滚到底部
			if (scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 30) {
				if (this.showMaxIdx > 0) {
					// 多展示20条信息
					this.showMaxIdx += 20;
				}
				// 已滚至消息底部
				if (this.showMaxIdx >= this.messageSize) {
					this.showMaxIdx = -1;
				}
				// 设置底部标志
				if (this.showMaxIdx < 0) {
					this.isInBottom = true;
					this.newMessageSize = 0;
				}
			}
			if (scrollElement.scrollHeight - scrollTop - scrollElement.clientHeight > 500) {
				this.isInBottom = false;
			} else {
				this.isInBottom = true;
			}
		},


		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onEmotion(emoText) {
			this.$refs.chatInputEditor.insertEmoji(emoText);
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		showPrivateVideo(mode) {
			if (!this.isFriend) {
				this.$message.error("你已不是对方好友,无法呼叫");
				return
			}
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			// 通话服务未配置时不发起呼叫，避免打开空窗口
			const livekit = this.$store.state.configStore.livekit;
			if (!livekit || !livekit.url) {
				this.$message.error("通话服务未配置，请联系管理员");
				return;
			}
			let rtcInfo = {
				mode: mode,
				isHost: true,
				friend: this.friend,
			}
			// 通过home.vue打开单人视频窗口
			this.$eventBus.$emit("openPrivateVideo", rtcInfo);
		},
		onGroupVideo() {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			this.$http({
				url: "/webrtc/group/info?groupId=" + this.group.id,
				method: 'GET'
			}).then((rtcInfo) => {
				if (rtcInfo.isChating) {
					// 已在通话中，可以直接加入通话
					this.$refs.rtcJoin.open(rtcInfo);
				} else {
					// 邀请成员发起通话
					let ids = [this.mine.id];
					let maxChannel = this.$store.state.configStore.webrtc.maxChannel;
					this.$refs.rtcSel.open(maxChannel, ids, ids, []);
				}
			})

		},
		onInviteOk(members) {
			if (members.length < 2) {
				return;
			}
			let userInfos = [];
			members.forEach(m => {
				userInfos.push({
					id: m.userId,
					nickName: m.showNickName,
					headImage: m.headImage,
					isCamera: false,
					isMicroPhone: true
				})
			})
			let rtcInfo = {
				isHost: true,
				groupId: this.group.id,
				inviterId: this.mine.id,
				userInfos: userInfos
			}
			// 通过home.vue打开多人视频窗口
			this.$eventBus.$emit("openGroupVideo", rtcInfo);
		},
		showHistoryBox() {
			this.showHistory = true;
		},
		onSendRecord(data) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			const chat = this.chat;
			let msgInfo = {
				content: JSON.stringify(data),
				type: 3,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(msgInfo, chat.targetId);
			this.sendMessageRequest(msgInfo).then((m) => {
				m.selfSend = true;
				this.$store.commit("insertMessage", [m, chat]);
				this.moveChatToTop(chat);
				if (this.chat !== chat) {
					return;
				}
				// 保持输入框焦点
				this.$refs.chatInputEditor.focus();
				// 滚动到底部
				this.scrollToBottom();
				// 关闭录音窗口
				this.showRecord = false;
				this.isReceipt = false;
				this.refreshPlaceHolder();
			})
		},
		fillTargetId(msgInfo, targetId) {
			if (this.isGroup) {
				msgInfo.groupId = targetId;
			} else {
				msgInfo.recvId = targetId;
			}
		},
		notifySend() {
			if (this.lockMessage) {
				return;
			}
			this.$refs.chatInputEditor.submit();
		},
		async sendMessage(fullList) {
			if (this.lockMessage) {
				return;
			}
			this.lockMessage = true;
			this.resetEditor();
			this.readedMessage();
			try {
				// 检查是否被封禁
				if (this.isBanned) {
					this.showBannedTip();
					return;
				}
				let sendText = this.isReceipt ? "[回执消息]" : "";
				for (let i = 0; i < fullList.length; i++) {
					let msg = fullList[i];
					switch (msg.type) {
						case "text":
							await this.sendTextMessage(sendText + msg.content, msg.atUserIds);
							break;
						case "image":
							await this.sendImageMessage(msg.content.file);
							break;
						case "file":
							await this.sendFileMessage(msg.content.file);
							break;
					}
				}
			} finally {
				this.lockMessage = false;
			}
		},
		sendImageMessage(file) {
			return new Promise((resolve, reject) => {
				this.onImageBefore(file);
				file.uploadController = new AbortController();
				uploadViaPresigned(file, {
					fileType: PRESIGNED_FILE_TYPE.IMAGE,
					onUploadProgress: (progressEvent) => this.updateUploadProgress(file, progressEvent),
					signal: file.uploadController.signal
				}).then((payload) => {
					this.onImageSuccess(wrapPresignedUploadFullResponse(payload), file);
					resolve();
				}).catch((res) => {
					this.onImageFail(res, file);
					reject();
				})
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			});
		},
		sendVideoMessage(file) {
			return new Promise((resolve, reject) => {
				this.onVideoBefore(file);
				file.uploadController = new AbortController();
				uploadViaPresigned(file, {
					fileType: PRESIGNED_FILE_TYPE.VIDEO,
					onUploadProgress: (progressEvent) => this.updateUploadProgress(file, progressEvent),
					signal: file.uploadController.signal
				}).then((payload) => {
					this.onVideoSuccess(wrapPresignedUploadFullResponse(payload), file);
					resolve();
				}).catch((res) => {
					this.onVideoFail(res, file);
					reject();
				})
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			});
		},
		sendTextMessage(sendText, atUserIds) {
			return new Promise((resolve, reject) => {
				if (!sendText.trim()) {
					reject();
				}
				let msgInfo = {
					content: sendText,
					type: 0
				}
				const chat = this.chat;
				// 填充对方id
				this.fillTargetId(msgInfo, chat.targetId);
				// 被@人员列表
				if (this.isGroup) {
					msgInfo.atUserIds = atUserIds;
					msgInfo.receipt = this.isReceipt;
				}
				// 引用消息必须属于当前会话，避免把别的会话的图带出去
				if (this.quoteMessage && this.canQuoteMessage(this.quoteMessage)) {
					msgInfo.quoteMessageId = this.quoteMessage.id
				}
				this.sendMessageRequest(msgInfo).then((m) => {
					m.selfSend = true;
					this.$store.commit("insertMessage", [m, chat]);
					this.moveChatToTop(chat);
				}).finally(() => {
					if (this.chat === chat) {
						this.scrollToBottom();
						this.isReceipt = false;
						this.quoteMessage = null;
					}
					resolve();
				});
			});
		},
		sendFileMessage(file) {
			return new Promise((resolve, reject) => {
				let check = this.$refs.fileUpload.beforeUpload(file);
				if (check) {
					this.$refs.fileUpload.onFileUpload({ file });
					resolve();
				} else {
					reject();
				}
			})
		},
		onDeleteMessage(msgInfo) {
			this.$confirm('确认删除消息?', '删除消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$store.commit("deleteMessage", [msgInfo, this.chat]);
			});
		},
		onRecallMessage(msgInfo) {
			this.$confirm('确认撤回消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let url = `/message/${this.chat.type.toLowerCase()}/recall/${msgInfo.id}`
				this.$http({
					url: url,
					method: 'delete'
				}).then((m) => {
					this.$message.success("消息已撤回");
					m.selfSend = true;
					this.$store.commit("recallMessage", [m, this.chat]);
				})
			});
		},
		onQuoteMessage(msgInfo) {
			if (msgInfo && !this.canQuoteMessage(msgInfo)) {
				return;
			}
			this.quoteMessage = msgInfo;
		},
		messageSelectKey(msg) {
			if (!msg) {
				return '';
			}
			return msg.id ? String(msg.id) : (msg.tmpId ? String(msg.tmpId) : '');
		},
		canForwardMessage(msg) {
			return !!(msg && msg.id
				&& this.$msgType.isNormal(msg.type)
				&& msg.status != this.$enums.MESSAGE_STATUS.RECALL
				&& msg.loadStatus != 'loading');
		},
		isMessageSelected(msg) {
			const key = this.messageSelectKey(msg);
			return !!key && this.selectedMessages.some((item) => this.messageSelectKey(item) === key);
		},
		findMessageByKey(key) {
			if (!key) {
				return null;
			}
			const shown = (this.showMessages || []).find((msg) => this.messageSelectKey(msg) === key);
			if (shown) {
				return shown;
			}
			const all = (this.chat && this.chat.messages) || [];
			return all.find((msg) => this.messageSelectKey(msg) === key) || null;
		},
		forwardableChatMessages() {
			return ((this.chat && this.chat.messages) || []).filter((msg) => this.canForwardMessage(msg));
		},
		mergeSelectedMessages(extra) {
			const next = [];
			const seen = new Set();
			const push = (msg) => {
				const key = this.messageSelectKey(msg);
				if (!key || seen.has(key) || !this.canForwardMessage(msg)) {
					return;
				}
				seen.add(key);
				next.push(msg);
			};
			(this.selectPress && this.selectPress.snapshot ? this.selectPress.snapshot : []).forEach(push);
			(extra || []).forEach(push);
			this.selectedMessages = next.slice(0, 50);
		},
		eventClientPoint(e) {
			if (e.touches && e.touches[0]) {
				return { x: e.touches[0].clientX, y: e.touches[0].clientY };
			}
			if (e.changedTouches && e.changedTouches[0]) {
				return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
			}
			return { x: e.clientX, y: e.clientY };
		},
		isSelectIgnoreTarget(target) {
			return !!(target && target.closest && target.closest('video, audio, a, input, button, textarea, .head-image, .msg-select-col, .right-menu, .scroll-to-bottom'));
		},
		unbindSelectListeners() {
			document.removeEventListener('mousemove', this.onSelectPointerMove, true);
			document.removeEventListener('mouseup', this.onSelectPointerUp, true);
			document.removeEventListener('touchmove', this.onSelectPointerMove, true);
			document.removeEventListener('touchend', this.onSelectPointerUp, true);
			document.removeEventListener('touchcancel', this.onSelectPointerUp, true);
			document.removeEventListener('selectstart', this.onSelectSelectStart, true);
		},
		onSelectSelectStart(e) {
			if (this.selectingMessages || (this.selectPress && this.selectPress.armed)) {
				e.preventDefault();
			}
		},
		clearSelectTimer() {
			if (this.selectTimer) {
				clearTimeout(this.selectTimer);
				this.selectTimer = null;
			}
		},
		onStartMultiSelect(msgInfo) {
			this.selectingMessages = true;
			this.selectedMessages = [];
			if (msgInfo && this.canForwardMessage(msgInfo)) {
				this.selectedMessages.push(msgInfo);
			}
		},
		clearSelectClickSwallower() {
			if (this.selectClickSwallower) {
				document.removeEventListener('click', this.selectClickSwallower, true);
				this.selectClickSwallower = null;
			}
		},
		onCancelMultiSelect() {
			this.clearSelectTimer();
			this.unbindSelectListeners();
			this.clearSelectClickSwallower();
			this.selectingMessages = false;
			this.selectedMessages = [];
			this.forwardingMessages = false;
			this.selectPress = null;
			this.selectSuppressClick = false;
		},
		addSelectedMessage(msgInfo) {
			if (!this.canForwardMessage(msgInfo) || this.isMessageSelected(msgInfo)) {
				return;
			}
			if (this.selectedMessages.length >= 50) {
				this.$message.warning('一次最多转发50条消息');
				return;
			}
			this.selectedMessages.push(msgInfo);
		},
		applySelectRange(clientY) {
			if (!this.selectPress) {
				return;
			}
			this.selectPress.lastY = clientY;
			const currentKey = this.findForwardKeyAtY(clientY);
			if (currentKey) {
				this.selectPress.endKey = currentKey;
				if (!this.selectPress.startKey) {
					this.selectPress.startKey = currentKey;
				}
			}
			const startKey = this.selectPress.startKey;
			const endKey = this.selectPress.endKey || currentKey;
			const list = this.forwardableChatMessages();
			let range = [];
			const startIdx = startKey ? list.findIndex((msg) => this.messageSelectKey(msg) === startKey) : -1;
			const endIdx = endKey ? list.findIndex((msg) => this.messageSelectKey(msg) === endKey) : -1;
			if (startIdx >= 0 && endIdx >= 0) {
				const from = Math.min(startIdx, endIdx);
				const to = Math.max(startIdx, endIdx);
				range = list.slice(from, to + 1);
			} else if (endIdx >= 0) {
				range = [list[endIdx]];
			} else if (startIdx >= 0) {
				range = [list[startIdx]];
			}
			this.mergeSelectedMessages(range);
		},
		armSelectFromPress() {
			if (!this.selectPress) {
				return;
			}
			this.selectPress.armed = true;
			this.selectingMessages = true;
			this.selectSuppressClick = true;
			if (window.getSelection) {
				window.getSelection().removeAllRanges();
			}
			const key = this.selectPress.startKey || this.findForwardKeyAtY(this.selectPress.y);
			this.selectPress.startKey = key;
			this.selectPress.endKey = key;
			this.selectPress.snapshot = [];
			this.selectedMessages = [];
			const msg = this.findMessageByKey(key);
			if (msg) {
				this.addSelectedMessage(msg);
			}
		},
		findForwardKeyAtY(y) {
			const box = document.getElementById('chatScrollBox');
			if (!box) {
				return '';
			}
			const nodes = box.querySelectorAll('.chat-msg-wrap[data-forward-key]');
			let bestKey = '';
			let bestDist = Infinity;
			for (let i = 0; i < nodes.length; i++) {
				const key = nodes[i].getAttribute('data-forward-key');
				if (!key) {
					continue;
				}
				const r = nodes[i].getBoundingClientRect();
				if (y >= r.top && y <= r.bottom) {
					return key;
				}
				const dist = y < r.top ? r.top - y : y - r.bottom;
				if (dist < bestDist) {
					bestDist = dist;
					bestKey = key;
				}
			}
			return bestKey;
		},
		onSelectPointerDown(e) {
			if (e.type === 'mousedown') {
				if (e.button !== 0) {
					return;
				}
				if (this.selectTouchStamp && (Date.now() - this.selectTouchStamp) < 700) {
					return;
				}
			}
			if (e.type === 'touchstart') {
				this.selectTouchStamp = Date.now();
			}
			if (this.isSelectIgnoreTarget(e.target)) {
				return;
			}
			const point = this.eventClientPoint(e);
			this.clearSelectTimer();
			this.unbindSelectListeners();
			this.selectPress = {
				x: point.x,
				y: point.y,
				lastY: point.y,
				startKey: this.findForwardKeyAtY(point.y) || '',
				endKey: '',
				snapshot: this.selectingMessages ? this.selectedMessages.slice() : [],
				armed: this.selectingMessages,
				moved: false,
				fromIdle: !this.selectingMessages
			};
			if (!this.selectingMessages) {
				this.selectTimer = setTimeout(() => {
					this.selectTimer = null;
					this.armSelectFromPress();
				}, 400);
			}
			document.addEventListener('mousemove', this.onSelectPointerMove, true);
			document.addEventListener('mouseup', this.onSelectPointerUp, true);
			document.addEventListener('touchmove', this.onSelectPointerMove, { capture: true, passive: false });
			document.addEventListener('touchend', this.onSelectPointerUp, true);
			document.addEventListener('touchcancel', this.onSelectPointerUp, true);
			document.addEventListener('selectstart', this.onSelectSelectStart, true);
		},
		onSelectPointerMove(e) {
			if (!this.selectPress) {
				return;
			}
			const point = this.eventClientPoint(e);
			const dx = point.x - this.selectPress.x;
			const dy = point.y - this.selectPress.y;
			const dist2 = dx * dx + dy * dy;
			if (!this.selectPress.armed) {
				if (dist2 >= 144) {
					this.clearSelectTimer();
					this.unbindSelectListeners();
					this.selectPress = null;
				}
				return;
			}
			if (dist2 < 36 && !this.selectPress.moved) {
				return;
			}
			this.selectPress.moved = true;
			this.selectSuppressClick = true;
			if (e.cancelable) {
				e.preventDefault();
			}
			const box = document.getElementById('chatScrollBox');
			if (box) {
				const br = box.getBoundingClientRect();
				if (point.y < br.top + 36) {
					box.scrollTop -= 24;
				} else if (point.y > br.bottom - 36) {
					box.scrollTop += 24;
				}
			}
			this.applySelectRange(point.y);
		},
		onSelectPointerUp() {
			const press = this.selectPress;
			const shouldSuppress = !!(press && press.armed && (press.moved || press.fromIdle));
			this.clearSelectTimer();
			this.unbindSelectListeners();
			this.selectPress = null;
			if (shouldSuppress) {
				this.selectSuppressClick = true;
				this.clearSelectClickSwallower();
				this.selectClickSwallower = (ev) => {
					ev.stopPropagation();
					ev.preventDefault();
					this.clearSelectClickSwallower();
				};
				document.addEventListener('click', this.selectClickSwallower, true);
				setTimeout(() => {
					this.clearSelectClickSwallower();
					this.selectSuppressClick = false;
				}, 80);
			} else {
				this.selectSuppressClick = false;
			}
		},
		onToggleSelectMessage(msgInfo, ev) {
			if (!this.selectingMessages || !this.canForwardMessage(msgInfo)) {
				return;
			}
			const fromCheck = !!(ev && ev.target && ev.target.closest && ev.target.closest('.msg-select-col'));
			if (!fromCheck && this.selectSuppressClick) {
				return;
			}
			const key = this.messageSelectKey(msgInfo);
			const idx = this.selectedMessages.findIndex((item) => this.messageSelectKey(item) === key);
			if (idx >= 0) {
				this.selectedMessages.splice(idx, 1);
				return;
			}
			this.addSelectedMessage(msgInfo);
		},
		normalizeForwardMessages(msgList) {
			return (msgList || []).filter((msg) => this.canForwardMessage(msg)).sort((a, b) => {
				const time = (a.sendTime || 0) - (b.sendTime || 0);
				if (time !== 0) {
					return time;
				}
				return (a.id || 0) - (b.id || 0);
			});
		},
		buildForwardPayload(msgInfo) {
			return {
				content: msgInfo.content,
				type: msgInfo.type,
				quoteMessageId: msgInfo.quoteMessageId,
				receipt: msgInfo.receipt,
				atUserIds: msgInfo.atUserIds
			};
		},
		async batchForwardMessage(msgInfo, chats) {
			const message = this.buildForwardPayload(msgInfo);
			const recvIdList = chats.filter((item) => item.type == 'PRIVATE').map((item) => item.targetId);
			const groupIdList = chats.filter((item) => item.type == 'GROUP').map((item) => item.targetId);
			if (recvIdList.length) {
				await this.$http({
					url: '/message/private/batchSend',
					method: 'post',
					data: { ...message, recvIdList }
				});
			}
			if (groupIdList.length) {
				await this.$http({
					url: '/message/group/batchSend',
					method: 'post',
					data: { ...message, groupIdList }
				});
			}
		},
		async sequentialForwardMessages(msgList, chats) {
			for (let i = 0; i < chats.length; i++) {
				const chat = chats[i];
				this.$store.commit('openChat', chat);
				for (let j = 0; j < msgList.length; j++) {
					const payload = this.buildForwardPayload(msgList[j]);
					if (chat.type == 'GROUP') {
						payload.groupId = chat.targetId;
					} else {
						payload.recvId = chat.targetId;
					}
					const m = await this.$http({
						url: `/message/${chat.type.toLowerCase()}/send`,
						method: 'post',
						data: payload
					});
					m.selfSend = true;
					this.$store.commit('insertMessage', [m, chat]);
				}
			}
		},
		async forwardMessages(msgList, chats, type) {
			const list = this.normalizeForwardMessages(msgList);
			if (!list.length || !chats || !chats.length) {
				return;
			}
			if (type) {
				for (let i = 0; i < list.length; i++) {
					await this.batchForwardMessage(list[i], chats);
				}
			} else {
				await this.sequentialForwardMessages(list, chats);
			}
			this.$message.success(list.length > 1 ? `已转发 ${list.length} 条消息` : '转发成功');
		},
		onForwardSelected() {
			if (this.forwardingMessages || !this.selectedMessages.length) {
				return;
			}
			const list = this.normalizeForwardMessages(this.selectedMessages);
			if (!list.length) {
				this.$message.warning('请先选择要转发的消息');
				return;
			}
			this.$refs.chatSel.open(async (chats, type) => {
				this.forwardingMessages = true;
				try {
					await this.forwardMessages(list, chats, type);
					this.onCancelMultiSelect();
				} catch (e) {
					this.$message.error((e && e.message) || '转发失败');
				} finally {
					this.forwardingMessages = false;
				}
			});
		},
		async onForwardMessage(msgInfo) {
			if (!this.canForwardMessage(msgInfo)) {
				return;
			}
			this.$refs.chatSel.open(async (chats, type) => {
				await this.forwardMessages([msgInfo], chats, type);
			});
		},

		onTopMessage(msgInfo) {
			// if (!msgInfo.id) {
			// 	this.$message.warning("请等待该消息发送成功后操作");
			// 	return;
			// }
			this.$http({
				url: `/group/setTopMessage/${msgInfo.groupId}?messageId=${msgInfo.id}`,
				method: 'post'
			}).then(() => { })
		},
		onRecallAll(msgInfo) {
			this.$confirm('确认对所有人撤回该消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let url = `/message/${this.chat.type.toLowerCase()}/recall/${msgInfo.id}`
				this.$http({
					url: url,
					method: 'delete'
				}).then((m) => {
					this.$message.success("消息已撤回");
					// m.selfSend = true;
					// this.$store.commit("recallMessage", [m, this.chat]);
				})
			});
		},
		async onCopyMessage(msgInfo) {
			try {
				const result = await copyMessageContent(msgInfo, this.$enums.MESSAGE_TYPE);
				if (result.kind === 'file') {
					this.$message.success('已复制，可在输入框粘贴发送');
				} else {
					this.$message.success('已复制');
				}
			} catch (e) {
				console.error('onCopyMessage:', e);
				this.$message.error('复制失败，请稍后重试');
			}
		},
		onLocateQuoteMessage(msgInfo) {
			this.locateMessage(msgInfo.quoteMessage);
		},
		locateMessage(msgInfo) {
			// 寻找消息位置
			const idx = this.findMessageIdx(msgInfo);
			if (idx < 0) {
				this.$message.error("无法定位原消息");
				return;
			}
			// 要定位到消息，首先要渲染这条消息
			this.showMinIdx = Math.max(idx - 10, 0);
			this.showMaxIdx = this.showMinIdx + 20;
			// 定位消息
			this.scrollToMessage(msgInfo.id, 100, 0);
			// 选中消息
			this.activeMessageIdx = idx;
			// 设置底部标记
			if (this.showMaxIdx > 0 && this.showMaxIdx < this.messageSize) {
				// 延时是为了在滚动事件触发之后设置
				setTimeout(() => {
					this.isInBottom = false;
					this.newMessageSize = 0;
				}, 100)
			}
			this.$refs.chatHistory.close();
		},

		scrollToMessage(id, delay, times) {
			setTimeout(() => {
				let messgaeItem = document.getElementById(id);
				if (messgaeItem) {
					messgaeItem.scrollIntoView({ behavior: 'smooth' });
				} else if (times < 3) {
					this.scrollToMessage(id, delay * 3, times + 1)
				} else {
					console.log("消息定位失败", delay)
				}
			}, delay)
		},

		resetShowMessages() {
			// 初始状态仅渲染最后30条数据
			this.showMinIdx = this.messageSize > 30 ? this.messageSize - 30 : 0;
			this.showMaxIdx = -1;
		},
		loadOlderMessages(scrollElement) {
			if (this.loadingOlder || this.hydratingChat || !this.chat || !this.chat.messagesTrimmed) {
				return;
			}
			this.loadingOlder = true;
			const el = scrollElement || document.getElementById("chatScrollBox");
			const prevHeight = el ? el.scrollHeight : 0;
			this.$store.dispatch("loadOlderChatMessages", this.chat).then((added) => {
				if (added) {
					this.showMinIdx += added;
					this.$nextTick(() => {
						if (el) {
							el.scrollTop += Math.max(0, el.scrollHeight - prevHeight);
						}
					});
				}
			}).finally(() => {
				this.loadingOlder = false;
			});
		},
		findMessageIdx(msgInfo) {
			for (let idx in this.chat.messages) {
				const message = this.chat.messages[idx];
				// 通过id判断
				if (msgInfo.id && message.id && message.id == msgInfo.id) {
					return idx;
				}
				// 正在发送中的消息可能没有id,只有tmpId
				if (msgInfo.tmpId && message.tmpId && message.tmpId == msgInfo.tmpId) {
					return idx;
				}
			}
			return -1;
		},
		readedMessage() {
			if (this.chat.unreadCount == 0) {
				return;
			}
			this.$store.commit("resetUnreadCount", this.chat)
			if (this.isGroup) {
				var url = `/message/group/readed?groupId=${this.chat.targetId}`
			} else {
				url = `/message/private/readed?friendId=${this.chat.targetId}`
			}
			this.$http({
				url: url,
				method: 'put'
			}).then(() => { })
		},
		loadReaded(fId) {
			this.$http({
				url: `/message/private/maxReadedId?friendId=${fId}`,
				method: 'get'
			}).then((id) => {
				this.$store.commit("readedMessage", {
					friendId: fId,
					maxId: id
				});
			});
		},
		loadGroup(groupId) {
			this.groupId = groupId;
			this.$http({
				url: `/group/find/${groupId}`,
				method: 'get'
			}).then((group) => {
				this.$store.commit("updateChatFromGroup", group);
				this.$store.commit("updateGroup", group);
			});
			this.$http({
				url: `/group/members/${groupId}`,
				method: 'get'
			}).then((groupMembers) => {
				this.groupMembers = groupMembers;
				this.groupManagers = groupMembers.filter((m) => m.isManager);
			});
		},
		updateFriendInfo() {
			try {
				if (this.isFriend) {
					// store的数据不能直接修改，深拷贝一份store的数据
					let friend = JSON.parse(JSON.stringify(this.friend));
					friend.headImage = this.userInfo.headImage || this.userInfo.headImageThumb;
					friend.nickName = this.userInfo.nickName;
					friend.userTag = this.userInfo.userTag;
					friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickName;
					this.$store.commit("updateChatFromFriend", friend);
					this.$store.commit("updateFriend", friend);
				} else {
					this.$store.commit("updateChatFromUser", this.userInfo);
				}
			} catch (error) {
				console.error('updateFriendInfo:', error)
			}
		},
		loadFriend(friendId) {
			// 获取好友信息
			this.$http({
				url: `/user/find/${friendId}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		showName(msgInfo) {
			if (!msgInfo) {
				return ""
			}
			if (msgInfo.sendId == this.mine.id) {
				return this.mine.nickName;
			}
			if (this.isGroup) {
				return "";
				// let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				// return member ? member.showNickName : msgInfo.sendNickName || "";
			}
			if (msgInfo.sendId && this.chat && String(msgInfo.sendId) !== String(this.chat.targetId)) {
				return msgInfo.sendNickName || "未知用户";
			}
			return this.chat.showName
		},
		headImage(msgInfo) {
			if (msgInfo.sendId == this.mine.id) {
				return this.mine.headImage || this.mine.headImageThumb
			}
			if (this.isGroup) {
				return "";
				// let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				// return member ? member.headImage : "";
			}
			if (msgInfo.sendId && this.chat && String(msgInfo.sendId) !== String(this.chat.targetId)) {
				return msgInfo.headImage || "";
			}
			return this.chat.headImage
		},
		resetEditor() {
			this.$nextTick(() => {
				this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor.focus();
			});
		},
		restoreEditor() {
			this.$nextTick(() => {
				if (this.$refs.chatInputEditor) {
					this.$refs.chatInputEditor.restoreDraft(this.chat);
					this.$refs.chatInputEditor.focus();
				}
			});
		},
		scrollToBottom() {
			this.resetShowMessages();
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
			});
		},
		refreshPlaceHolder() {
			if (this.isReceipt) {
				this.placeholder = "[回执消息]"
			} else if (this.$refs.editBox && this.$refs.editBox.innerHTML) {
				this.placeholder = ""
			} else {
				this.placeholder = "聊点什么吧~";
			}
		},
		sendMessageRequest(msgInfo) {
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求"后发先至"，导致消息错序
				this.reqQueue.push({ msgInfo, resolve, reject });
				this.processReqQueue();
			})
		},
		processReqQueue() {
			if (this.reqQueue.length && !this.isSending) {
				this.isSending = true;
				const reqData = this.reqQueue.shift();
				this.$http({
					// url: this.messageAction, //由于异步操作，需要使用file存储的chat类型以决定使用哪个接口
					url: `/message/${reqData.msgInfo.chatType || this.chat.type.toLowerCase()}/send`,
					method: 'post',
					data: reqData.msgInfo
				}).then((res) => {
					reqData.resolve(res)
				}).catch((e) => {
					reqData.reject(e)
				}).finally(() => {
					this.isSending = false;
					// 发送下一条请求
					this.processReqQueue();
				})
			}
		},
		showBannedTip() {
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				sendTime: new Date().getTime(),
				type: this.$enums.MESSAGE_TYPE.TIP_TEXT
			}
			if (this.chat.type == "PRIVATE") {
				msgInfo.recvId = this.mine.id
				msgInfo.content = "该用户已被管理员封禁,原因:" + this.userInfo.reason
			} else {
				msgInfo.groupId = this.group.id;
				msgInfo.content = "本群聊已被管理员封禁,原因:" + this.group.reason
			}
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
		},
		generateId() {
			// 生成临时id
			return String(new Date().getTime()) + String(Math.floor(Math.random() * 1000));
		},
		onUndo() {
			if (this.canUndo) {
				this.$refs.chatInputEditor.undo();
			}
		},
		onRedo() {
			if (this.canRedo) {
				this.$refs.chatInputEditor.redo();
			}
		},
		onUndoRedoState({ canUndo, canRedo }) {
			this.canUndo = canUndo;
			this.canRedo = canRedo;
		},
		onResizeMouseDown(e) {
			if (isH5()) {
				return;
			}
			this.resizing = true;
			this.startY = e.clientY;
			this.startHeight = this.footerHeight;
			document.addEventListener('mousemove', this.onResizing);
			document.addEventListener('mouseup', this.onResizeMouseUp);
		},
		onResizing(e) {
			if (!this.resizing) return;
			let delta = this.startY - e.clientY;
			let newHeight = this.startHeight + delta;
			newHeight = Math.max(120, Math.min(newHeight, 500));
			this.footerHeight = newHeight;
		},
		loadFooterHeight() {
			const userId = this.mine?.id;
			if (!userId) return;
			const key = `footerHeight_${userId}`;
			const val = localStorage.getItem(key);
			if (val && !isNaN(Number(val))) {
				this.footerHeight = Number(val);
			} else {
				this.footerHeight = 220;
			}
		},
		onResizeMouseUp() {
			this.resizing = false;
			document.removeEventListener('mousemove', this.onResizing);
			document.removeEventListener('mouseup', this.onResizeMouseUp);
			const userId = this.mine?.id;
			if (userId) {
				const key = `footerHeight_${userId}`;
				localStorage.setItem(key, this.footerHeight);
			}
		},
		onShowInfo() {
			this.showInfoDialog = true;
		},
		onH5Back() {
			this.$store.dispatch("activateChat", -1);
		},
		onPasteFiles(files) {
			try {
				if (!files || !Array.isArray(files) || files.length === 0) {
					console.warn('Invalid files in onPasteFiles');
					return;
				}

				// 验证文件对象
				let validFiles = files.filter(file => {
					return file && file instanceof File && file.name && file.size >= 0;
				});

				if (validFiles.length === 0) {
					console.warn('No valid files found in onPasteFiles');
					return;
				}

				this.showFileConfirmDialog = true;
				this.dragFiles = Array.from(validFiles);
			} catch (error) {
				console.error('Error in onPasteFiles:', error);
			}
		},
		onGlobalUploadSuccess(payload) {
			// 仅当当前会话匹配文件携带的chat信息时插入消息
			const { data, file, action } = payload || {};
			if (!file || !file.msgInfo || !file.chat) return;
			// 根据action判断类型
			if (action && action.indexOf('/image/upload') !== -1) {
				this.onImageSuccess(data, file);
			} else if (action && action.indexOf('/video/upload') !== -1) {
				this.onVideoSuccess(data, file);
			} else {
				// 兼容文件
				this.onFileSuccess(data, file);
			}
		},
		onGlobalUploadFail(payload) {
			const { error, file, action, canceled } = payload || {};
			if (!file || !file.msgInfo || !file.chat) return;
			if (action && action.indexOf('/image/upload') !== -1) {
				this.onImageFail(error, file, canceled);
			} else if (action && action.indexOf('/video/upload') !== -1) {
				this.onVideoFail(error, file, canceled);
			} else {
				this.onFileFail(error, file, canceled);
			}
		},
		onGlobalUploadProgress(payload) {
			const { progressEvent, file } = payload || {};
			if (!file || !file.msgInfo || !file.chat) {
				return;
			}
			this.updateUploadProgress(file, progressEvent);
		}
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo;
		},
		displayFooterHeight() {
			if (this.selectingMessages) {
				return 0;
			}
			if (isH5()) {
				return Math.min(this.footerHeight, 168);
			}
			return this.footerHeight;
		},
		forwardSelectorTitle() {
			const n = this.selectedMessages.length;
			return n > 1 ? `转发 ${n} 条消息` : '转发消息';
		},
		isFriend() {
			return this.$store.getters.isFriend(this.userInfo.id);
		},
		friend() {
			const f = this.$store.getters.findFriend(this.userInfo.id);
			if (!f) {
				return {};
			}
			const online = this.$store.getters.friendOnline(this.userInfo.id);
			if (f.online === online.online && f.onlineWeb === online.onlineWeb && f.onlineApp === online.onlineApp) {
				return f;
			}
			return Object.assign({}, f, online);
		},
		group() {
			return this.$store.getters.findGroup(this.groupId) || {};
		},
		groupCount() {
			return this.group.memberCount || this.groupMembers.filter(m => !m.quit).length;
		},
		title() {
			let title = this.chat.showName;
			if (this.isGroup) {
				title += `(${this.groupCount || '...'})`;
			}
			return title;
		},
		messageAction() {
			return `/message/${this.chat.type.toLowerCase()}/send`;
		},
		unreadCount() {
			return this.chat.unreadCount;
		},
		showMessages() {
			const messages = (this.chat && this.chat.messages) || [];
			if (this.showMaxIdx > 0) {
				return messages.slice(this.showMinIdx, this.showMaxIdx)
			}
			return messages.slice(this.showMinIdx)
		},
		messageSize() {
			if (!this.chat || !this.chat.messages) {
				return 0;
			}
			return this.chat.messages.length;
		},
		isBanned() {
			return (this.isPrivate && this.userInfo.isBanned) ||
				(this.isGroup && this.group.isBanned)
		},
		isGroup() {
			return this.chat.type == 'GROUP';
		},
		isManager() {
			let userId = this.mine.id;
			let m = this.groupMembers.find((m) => m.userId == userId);
			return m && m.isManager;
		},
		isShowVoice() {
			if (this.chat.type == 'GROUP') {
				if (this.group.isVoiceCall || this.group.ownerId == this.mine.id || this.isManager) {
					return true
				}
			}
			return false
		},
		/**
		 * Whether the current chat is a private chat.
		 * @return {Boolean}
		 */
		isPrivate() {
			return this.chat.type == 'PRIVATE';
		},
		officialUserTag() {
			if (!this.chat || !this.isPrivate) {
				return 0;
			}
			if (this.userInfo && this.userInfo.userTag != null) {
				return this.userInfo.userTag;
			}
			const friend = this.$store.getters.findFriend(this.chat.targetId);
			if (friend && friend.userTag != null) {
				return friend.userTag;
			}
			return this.chat.userTag;
		},
		quickReplyCategories() {
			return [...new Set(this.quickReplies.map(item => item.category).filter(Boolean))];
		},
		recentQuickReplies() {
			const itemMap = new Map(this.quickReplies.map(item => [item.id, item]));
			return (this.quickReplyRecentIds || [])
				.map(id => itemMap.get(id))
				.filter(Boolean);
		},
		filteredQuickReplies() {
			const keyword = (this.quickReplyKeyword || '').toLowerCase();
			return this.quickReplies
				.filter(item => {
					const hitCategory = this.quickReplyCategoryFilter === 'all' || item.category === this.quickReplyCategoryFilter;
					if (!hitCategory) return false;
					if (!keyword) return true;
					const haystack = `${item.title} ${item.content} ${item.category}`.toLowerCase();
					return haystack.includes(keyword);
				})
				.sort((a, b) => {
					if (!!a.isPinned !== !!b.isPinned) {
						return a.isPinned ? -1 : 1;
					}
					const aRecent = (this.quickReplyRecentIds || []).indexOf(a.id);
					const bRecent = (this.quickReplyRecentIds || []).indexOf(b.id);
					if (aRecent >= 0 || bRecent >= 0) {
						if (aRecent < 0) return 1;
						if (bRecent < 0) return -1;
						return aRecent - bRecent;
					}
					if ((a.lastUsedAt || 0) !== (b.lastUsedAt || 0)) {
						return (b.lastUsedAt || 0) - (a.lastUsedAt || 0);
					}
					return a.title.localeCompare(b.title);
				});
		},
		quickReplyEmptyText() {
			if (this.quickReplies.length === 0) {
				return '已清空，可点击恢复预置话术';
			}
			return '暂无匹配话术';
		}
	},
	watch: {
		chat: {
			handler(newChat, oldChat) {
				if (newChat.targetId > 0 && (!oldChat || newChat.type != oldChat.type ||
					newChat.targetId != oldChat.targetId)) {
					this.userInfo = {};
					this.groupId = null;
					this.groupMembers = [];
					if (this.isGroup) {
						this.loadGroup(this.chat.targetId);
					} else {
						this.loadFriend(this.chat.targetId);
						// 加载已读状态
						this.loadReaded(this.chat.targetId)
					}
					if (this.isInBottom) {
						// 滚到底部
						this.scrollToBottom();
					}
					this.showSide = false;
					// 消息已读
					this.readedMessage()
					// 初始状态只显示30条消息
					this.resetShowMessages();
					// 切换会话时恢复该会话草稿，不要清空成别人的输入
					this.restoreEditor();
					// 复位回执消息
					this.isReceipt = false;
					// 清空引用消息
					this.quoteMessage = null;
					// 复位底部标记
					// this.isInBottom = true;
					this.newMessageSize = 0;
					// 更新placeholder
					this.refreshPlaceHolder();
					this.loadFooterHeight();
					this.syncCurrentChatRecentIds();
					this.onCancelMultiSelect();
					if (newChat.messagesTrimmed && !newChat.messagesHydrated) {
						this.hydratingChat = true;
						this.$store.dispatch("hydrateChatMessages", newChat).then(() => {
							this.resetShowMessages();
							this.scrollToBottom();
							this.newMessageSize = 0;
						}).finally(() => {
							this.hydratingChat = false;
						});
					}
				}
			},
			immediate: true
		},

		messageSize: {
			handler(newSize, oldSize) {
				if (this.hydratingChat) {
					return;
				}
				if (newSize > oldSize) {
					// 收到普通消息,则滚动至底部
					let lastMessage = this.chat.messages[newSize - 1];
					if (lastMessage && this.$msgType.isNormal(lastMessage.type)) {
						if (this.isInBottom) {
							this.scrollToBottom();
						} else {
							this.newMessageSize++;
						}
					}
				}
			}
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		if (div) {
			div.addEventListener('scroll', this.onScroll);
			div.addEventListener('mousedown', this.onSelectPointerDown, true);
			div.addEventListener('touchstart', this.onSelectPointerDown, { capture: true, passive: true });
		}
		this.loadFooterHeight();
		this.loadQuickReplies();
		this.loadQuickReplyRecentMap();
		window.addEventListener('keydown', this.keyDown)
		try {
			this.$eventBus && this.$eventBus.$on('upload:success', this.onGlobalUploadSuccess);
			this.$eventBus && this.$eventBus.$on('upload:fail', this.onGlobalUploadFail);
			this.$eventBus && this.$eventBus.$on('upload:progress', this.onGlobalUploadProgress);
		} catch (e) { console.warn('upload event bind error', e); }
		if (this.searchHistory.show) {
			setTimeout(() => {
				this.showHistoryBox();
			}, 100)
		}
	},
	beforeDestroy() {
		try {
			this.$eventBus && this.$eventBus.$off('upload:success', this.onGlobalUploadSuccess);
			this.$eventBus && this.$eventBus.$off('upload:fail', this.onGlobalUploadFail);
			this.$eventBus && this.$eventBus.$off('upload:progress', this.onGlobalUploadProgress);
		} catch (e) { console.warn('upload event unbind error', e); }
		window.removeEventListener('keydown', this.keyDown);
		const box = document.getElementById("chatScrollBox");
		if (box) {
			box.removeEventListener('mousedown', this.onSelectPointerDown, true);
			box.removeEventListener('touchstart', this.onSelectPointerDown, true);
		}
		this.onCancelMultiSelect();
	}
}
</script>

<style lang="scss">
.chat-box {
	position: relative;
	width: 100%;
	background: #fff;
	height: 100%;

	.el-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 12px;
		line-height: 50px;
		font-size: var(--im-font-size-larger);
		border-bottom: var(--im-border);
		position: relative;

		.btn-side {
			position: absolute;
			right: 20px;
			line-height: 50px;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);
			display: flex;
			align-items: center;
			top: 50%;
			transform: translate(0, -50%);
		}

		.more-info {
			margin-left: 12px;
		}

		.clear-chat {
			margin-left: 12px;
			font-size: 1rem;
		}

		&.is-msg-selecting {
			justify-content: space-between;

			.select-forward-top,
			.select-close {
				cursor: pointer;
				user-select: none;
				color: var(--im-color-primary);
				font-size: 16px;
				font-weight: 600;
			}

			.select-forward-top.disabled {
				opacity: 0.45;
				cursor: not-allowed;
			}
		}
	}

	.content-box {
		position: relative;

		.im-chat-main {
			padding: 0 10px;
			background-color: #fff;

			img {
				-webkit-user-drag: none;
			}

			.chat-msg-wrap {
				width: 100%;
			}

			&.is-msg-selecting {
				user-select: none;
				-webkit-user-select: none;
			}
		}

		.scroll-to-bottom {
			text-align: right;
			position: absolute;
			right: 20px;
			bottom: 0; // 由内联style动态控制
			color: var(--im-color-primary);
			font-size: var(--im-font-size);
			font-weight: 600;
			background: #ddd;
			padding: 5px 20px;
			border-radius: 15px;
			cursor: pointer;
			z-index: 99;
			box-shadow: var(--im-box-shadow-light);
			opacity: 0.85;
		}

		.im-chat-footer {
			display: flex;
			flex-direction: column;
			padding: 0;
			position: relative;

			.resize-bar {
				height: 6px;
				background: #e0e0e0;
				cursor: ns-resize;
				width: 100%;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 1;
				border-radius: 3px 3px 0 0;
				transition: background 0.2s;
			}

			.resize-bar:hover {
				background: #b0b0b0;
			}

			.chat-tool-bar {
				display: flex;
				position: relative;
				width: 100%;
				height: 36px;
				text-align: left;
				box-sizing: border-box;
				border-top: var(--im-border);
				padding: 4px 2px 2px 8px;

				>div {
					font-size: 22px;
					cursor: pointer;
					line-height: 30px;
					width: 30px;
					height: 30px;
					text-align: center;
					border-radius: 2px;
					margin-right: 8px;
					color: #999;
					transition: 0.3s;

					&.chat-tool-active {
						font-weight: 600;
						color: var(--im-color-primary);
						background-color: #ddd;
					}
				}

				>div:hover {
					color: #333;
				}
			}

			.send-content-area {
				position: relative;
				display: flex;
				flex-direction: column;
				height: 100%;
				background-color: white !important;
				z-index: 5;

				.quote-message {
					position: absolute;
					bottom: 10px;
					left: 10px;
					font-size: 14px;
					max-width: 80%;
					border-radius: 5px;

					&:hover .quote-remove {
						display: block;
					}

					.quote-remove {
						display: none;
						position: absolute;
						top: -8px;
						right: -8px;
						width: 20px;
						height: 20px;
						line-height: 20px;
						font-size: 14px;
						color: white;
						border-radius: 50%;
						background: #aaa;
						cursor: pointer;

						&:hover {
							background: #888;
						}

					}
				}

				.send-btn-area {
					padding: 10px;
					position: absolute;
					bottom: 4px;
					right: 6px;
				}
			}
		}
	}

	.chat-group-side-box {
		border-left: var(--im-border);
	}
}

.chat-tool-disabled {
	pointer-events: none;
	color: #ccc !important;
}

.quick-reply-toolbar {
	display: grid;
	grid-template-columns: 1fr 160px auto;
	gap: 10px;
	margin-bottom: 10px;
	align-items: center;
}

.quick-reply-toolbar__actions {
	display: flex;
	align-items: center;
	gap: 8px;
	white-space: nowrap;
}

.quick-reply-recent {
	margin-bottom: 10px;
	padding: 10px;
	border-radius: 6px;
	background: #f7fbff;
	border: 1px solid #e3f0ff;
}

.quick-reply-recent__title {
	font-size: 12px;
	color: #909399;
	margin-bottom: 8px;
}

.quick-reply-recent__items {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.quick-reply-recent__tag {
	cursor: pointer;
	border-color: #dcdfe6;
}

.quick-reply-recent__tag.is-selected {
	border-color: var(--im-color-primary);
	color: var(--im-color-primary);
	background: #ecf5ff;
}

.quick-reply-list {
	max-height: 340px;
	overflow-y: auto;
	border: 1px solid #ebeef5;
	border-radius: 6px;
	padding: 10px;
}

.quick-reply-item {
	padding: 8px 10px;
	border-radius: 4px;
	border: 1px solid #f2f4f7;
	background: #fafbfc;
}

.quick-reply-item+.quick-reply-item {
	margin-top: 8px;
}

.quick-reply-item__head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
}

.quick-reply-item__title {
	font-size: 14px;
	font-weight: 600;
	color: #303133;
	display: flex;
	align-items: center;
	gap: 5px;
}

.quick-reply-item__tags {
	display: flex;
	align-items: center;
	gap: 6px;
}

.quick-reply-item__pin-icon {
	color: #e6a23c;
}

.quick-reply-item__content {
	font-size: 13px;
	color: #606266;
	line-height: 1.6;
	margin-top: 6px;
	white-space: pre-wrap;
	word-break: break-word;
	text-align: left;
}

.quick-reply-item__actions {
	margin-top: 4px;
	text-align: right;
}

.quick-reply-empty {
	text-align: center;
	color: #909399;
	padding: 12px;
}

.quick-reply-create {
	margin-top: 12px;
	border-top: 1px dashed #ebeef5;
	padding-top: 12px;
}

.quick-reply-create__title {
	font-size: 13px;
	color: #909399;
	margin-bottom: 8px;
}

.quick-reply-create__row {
	display: grid;
	grid-template-columns: 1fr 180px;
	gap: 10px;
	margin-bottom: 8px;
}

.quick-reply-create__actions {
	margin-top: 8px;
	display: flex;
	justify-content: flex-end;
	gap: 8px;
}

.chat-title {
	cursor: pointer;
	color: var(--im-color-primary);
	display: inline-flex;
	align-items: center;
	gap: 8px;
	line-height: 1;

	.chat-title-name {
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	&:hover {
		text-decoration: underline;
	}

	.online {
		color: #60a942;
	}

	.offline {
		color: #C0C4CC;
	}
}

.info-dialog .el-dialog__body {
	padding: 28px 32px 24px 32px;
	background: linear-gradient(135deg, #fafdff 0%, #f3f6fb 100%);
}

.info-content {
	display: flex;
	align-items: flex-start;
	gap: 24px;
}

.info-avatar {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 2px 12px #e0e7ef80;
	padding: 8px;
}

.info-fields {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 12px;
	font-size: 16px;
}

.info-row {
	display: flex;
	align-items: flex-start;
	min-height: 24px;
}

.info-label {
	color: #888;
	font-weight: bold;
	display: inline-block;
	width: 120px;
	text-align: right;
}

.info-value {
	color: #222;
	word-break: break-all;
	flex: 1;
}

.info-value-name {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	justify-content: center;
}

.notice-value {
	border-radius: 4px;
	padding: 2px 8px;
	font-size: 15px;
	line-height: 1.7;
	margin-left: 0;
}

.info-dialog-optim .el-dialog {
	border-radius: 12px !important;
	box-shadow: 0 8px 32px #b3c6e080, 0 1.5px 8px #e0e7ef60;
	overflow: hidden;
}

.info-dialog-optim .el-dialog__header {
	border-radius: 12px 12px 0 0;
	background: linear-gradient(90deg, #eaf6ff 0%, #fafdff 100%);
	font-size: 22px;
	font-weight: bold;
	letter-spacing: 1px;
	padding-top: 24px;
	padding-bottom: 18px;
}

.info-dialog-optim .el-dialog__body {
	padding: 36px 44px 32px 44px;
	background: linear-gradient(135deg, #fafdff 0%, #f3f6fb 100%);
}

// 拖拽遮罩样式
.drag-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.6);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
	pointer-events: none;

	.drag-content {
		text-align: center;
		color: #fff;
		background-color: rgba(255, 255, 255, 0.1);
		padding: 40px;
		border-radius: 12px;
		backdrop-filter: blur(10px);
		border: 2px dashed rgba(255, 255, 255, 0.3);

		.el-icon-upload {
			font-size: 60px;
			margin-bottom: 20px;
			color: #fff;
		}

		.drag-text {
			font-size: 24px;
			font-weight: bold;
			margin-bottom: 10px;
		}

		.drag-tip {
			font-size: 16px;
			color: #ccc;
		}
	}
}

.chat-box.drag-over {
	.drag-overlay {
		pointer-events: auto;
	}
}

// 文件确认对话框样式
.file-confirm-content {
	.file-list {
		max-height: 300px;
		overflow-y: auto;
		margin-bottom: 20px;

		.file-item {
			display: flex;
			align-items: center;
			padding: 12px;
			border: 1px solid #e4e7ed;
			border-radius: 6px;
			margin-bottom: 8px;
			background-color: #fafafa;

			&:last-child {
				margin-bottom: 0;
			}

			.file-icon {
				width: 40px;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #f0f2f5;
				border-radius: 4px;
				margin-right: 12px;

				i {
					font-size: 20px;
					color: #606266;
				}
			}

			.file-preview {
				width: 60px;
				height: 60px;
				margin-right: 12px;
				border-radius: 4px;
				overflow: hidden;
				background-color: #f0f2f5;
				display: flex;
				align-items: center;
				justify-content: center;

				.image-preview {
					width: 100%;
					height: 100%;
					object-fit: cover;
					border-radius: 4px;
				}
			}

			.file-info {
				flex: 1;

				.file-name {
					font-size: 14px;
					color: #303133;
					margin-bottom: 4px;
					word-break: break-all;
				}

				.file-size {
					font-size: 12px;
					color: #909399;
				}
			}
		}
	}
}

.dialog-footer {
	text-align: right;
}
</style>